<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="productSourcingMatched-container" v-if="!mobile">
            <div class="productSourcingMatched-detail">
                <div class="productSourcingMatched-header">
                    <div class="productSourcingMatched-title">
                        <span class="productSourcingMatched-title-name">{{ title }}</span>
                        <div class="productSourcingMatched-title-unread" v-if="unread">{{
                            $t("lbl_EMPBE_SalesLead_Unread") }}</div>
                        <span class="productSourcingMatched-title-viewed" :class="{ 'is-unlocked': isQuotaUnlocked }" v-else-if="viewedOnText">
                            <img
                                v-if="isQuotaUnlocked"
                                class="productSourcingMatched-title-viewed__lock"
                                :src="unlockedChipLockImg"
                                width="15"
                                height="16"
                                alt=""
                            />
                            <span>{{ viewedOnText }}</span>
                        </span>
                    </div>
                    <div class="productSourcingMatched-subtitle">
                        <span class="productSourcingMatched-subtitle-date"> {{ GetDate }} </span>
                        <TipsAndPrivewDilog
                            v-if="visibilityTipText && simulatedSupplier"
                            class="productSourcingMatched-visibility-tip"
                            :id="`SalesLead_Sourcing_VisibilityTip_${rid || 0}`"
                            :Title="visibilityTipText"
                        >
                            <template v-slot:Text></template>
                        </TipsAndPrivewDilog>
                        <span class="productSourcingMatched-subtitle-unicode" v-html="GetCodeText"></span>

                    </div>
                </div>
                <div class="productSourcingMatched-unLock" v-if="showUnlockBanner" v-show="isContactLocked">
                    <unlockQuota_Free
                        Type="2"
                        unlockType="SourcingRequest"
                        :user="user"
                        :rid="rid"
                        :mobile="mobile"
                        :simulatedSupplier="simulatedSupplier"
                        @unlockQuota="onUnlockQuota"
                        @unlockQuotaInfo="onUnlockQuotaInfo"
                    />
                </div>
                <div class="productSourcingMatched-body-container">
                    <div class="productSourcingMatched-body">
                        <div class="productSourcingMatched-body-left">
                            <div class="productSourcingMatched-body-left-Title">
                                <div class="productSourcingMatched-body-left-header">{{
                                    $t("lbl_EMPBE_SalesLead_DetailsSourcingRequest") }}</div>
                                <div class="productSourcingMatched-body-left-header-Date">{{ ObjData.sourcingRequestDate
                                }}</div>
                            </div>
                            <div
                                class="productSourcingMatched-exhibition-banner"
                                v-if="isExhibitionBuyer"
                            >
                                <img
                                    class="productSourcingMatched-exhibition-banner__icon"
                                    src="https://cdn.adsalecdn.com/EMP/Backend/Images/light_bulb.svg"
                                    alt=""
                                    width="20"
                                    height="20"
                                />
                                <div
                                    class="productSourcingMatched-exhibition-banner__text"
                                    v-html="$t('lbl_EMPBE_SalesLead_ExhibitionTips')"
                                ></div>
                            </div>
                            <div class="productSourcingMatched-body-left-requirment-container">
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.content">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_LookingForProduct") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.content }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.productDesc">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_ProductPropertiesAndOtherRequirements") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.productDesc }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.natureText">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingNature") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail natureText"> {{
                                            ObjData.natureText }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.catsName">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingCategory") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.catsName }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment"
                                    v-if="ObjData.productTargetQuantity">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingRequestQuantity") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.productTargetQuantity }}</span>
                                    </div>
                                </div>
                            </div>
                            <!--贵司的回复-->
                            <div v-if="SalesLeadType == 1" class="productSourcingMatched-body-left-ContactBuyer">
                                <div class="productSourcingMatched-body-left-ContactBuyer-Svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="311" viewBox="0 0 17 311"
                                        fill="none">
                                        <path d="M1 0V294C1 302.837 8.16344 310 17 310V310" stroke="black"
                                            stroke-opacity="0.1" />
                                    </svg>
                                </div>
                                <div class="productSourcingMatched-body-left-ContactBuyer-Nav">
                                    <div class="productSourcingMatched-body-left-Title">
                                        <div class="productSourcingMatched-body-left-header">
                                            {{ $t("lbl_EMPBE_SalesLead_YourReply") }}</div>
                                        <div class="productSourcingMatched-body-left-header-Date">{{
                                            ObjData.contactBuyerDate }}</div>
                                    </div>

                                    <div class="productSourcingMatched-body-left-requirment-container">
                                        <div class="productSourcingMatched-body-left-requirment">
                                            <span class="productSourcingMatched-body-left-requirment-title">{{
                                                $t("lbl_EMPBE_SalesLead_YourReply_Content") }}</span>
                                            <div class="productSourcingMatched-body-left-requirment-detail-container">
                                                <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                                    ObjData.contactBuyerContent }}</span>
                                            </div>
                                        </div>
                                        <div class="productSourcingMatched-body-left-requirment">
                                            <span class="productSourcingMatched-body-left-requirment-title">{{
                                                $t("lbl_EMPBE_SalesLead_YourReply_Url") }}</span>
                                            <div class="productSourcingMatched-body-left-requirment-detail-container">
                                                <span class="productSourcingMatched-body-left-requirment-detail"><a
                                                        v-if="ObjData.productUrl"
                                                        target="_blank"
                                                        :href="GetContactBuyerUrl">{{
                                                            ObjData.productUrl }}</a></span>
                                            </div>
                                        </div>
                                        <div class="productSourcingMatched-body-left-requirment" v-if="GetContactBuyerFiles.length>0">
                                            <span class="productSourcingMatched-body-left-requirment-title">{{$t("lbl_EMPBE_SalesLead_PictureCatalogue")}}</span>
                                            <div class="productSourcingMatched-body-left-requirment-detail-container">
                                                <div class="productSourcingMatched-body-left-requirment-detail">
                                                    <div class="file-BG">
                                                        <a v-for="(item, index) in GetContactBuyerFiles" :key="index"
                                                            :href="GetFileType(item.FileName) != 0 ? item.FileName : 'javaScript:;'" v-if="GetFileType(item.FileName) !=-1">
                                                            <div class="file-Bg-Nav">
                                                                <img class="ContactBuyerPhoto"
                                                                    @click="ShowImgModel(item.FileName)"
                                                                    v-if="GetFileType(item.FileName) == 0"
                                                                    :src="item.FileName" />
                                                                <span class="" v-if="GetFileType(item.FileName) == 1">

                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48"
                                                                        height="48" viewBox="0 0 48 48" fill="none">
                                                                        <g clip-path="url(#clip0_1853_1813)">
                                                                            <path fill-rule="evenodd"
                                                                                clip-rule="evenodd"
                                                                                d="M8.02 8C8.02 5.8 9.8 4 12 4H28L40 16V40C40 42.2 38.2 44 36 44H11.98C9.78 44 8 42.2 8 40L8.02 8ZM26 7V18H37L26 7ZM31.5436 32.0195V30.0566H35.1939V28.4688H31.5436H30.9576H29.4869V37H31.5436V33.6016H34.86V32.0195H31.5436ZM24.4139 37H23.699H22.5213H21.6424V28.4688H22.4861H23.699H24.3846C24.9627 28.4688 25.492 28.5684 25.9725 28.7676C26.4568 28.9629 26.8748 29.2441 27.2264 29.6113C27.5818 29.9746 27.8553 30.4062 28.0467 30.9062C28.242 31.4023 28.3396 31.9531 28.3396 32.5586V32.916C28.3396 33.5176 28.242 34.0684 28.0467 34.5684C27.8553 35.0684 27.5838 35.5 27.2322 35.8633C26.8807 36.2266 26.4646 36.5078 25.9842 36.707C25.5076 36.9023 24.9842 37 24.4139 37ZM24.4139 35.418H23.699V30.0566H24.3846C24.6854 30.0566 24.951 30.1094 25.1814 30.2148C25.4158 30.3203 25.6111 30.4785 25.7674 30.6895C25.9236 30.8965 26.0408 31.1562 26.1189 31.4688C26.201 31.7773 26.242 32.1367 26.242 32.5469V32.916C26.242 33.4629 26.1697 33.9238 26.0252 34.2988C25.8846 34.6699 25.6775 34.9492 25.4041 35.1367C25.1346 35.3242 24.8045 35.418 24.4139 35.418ZM15.8076 34.1055H17.1553C17.8389 34.1055 18.4268 33.9922 18.9189 33.7656C19.415 33.5352 19.7959 33.2148 20.0615 32.8047C20.3271 32.3945 20.46 31.9141 20.46 31.3633C20.46 30.8047 20.3271 30.3086 20.0615 29.875C19.7959 29.4375 19.415 29.0938 18.9189 28.8438C18.4268 28.5938 17.8389 28.4688 17.1553 28.4688H13.751V37H15.8076V34.1055ZM15.8076 32.5176V30.0566H17.1553C17.4443 30.0566 17.6787 30.1191 17.8584 30.2441C18.0381 30.3652 18.1689 30.5254 18.251 30.7246C18.3369 30.9238 18.3799 31.1406 18.3799 31.375C18.3799 31.5938 18.3369 31.791 18.251 31.9668C18.1689 32.1387 18.0381 32.2734 17.8584 32.3711C17.6787 32.4688 17.4443 32.5176 17.1553 32.5176H15.8076Z"
                                                                                fill="#E92425" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_1853_1813">
                                                                                <rect width="48" height="48"
                                                                                    fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="" v-if="GetFileType(item.FileName) == 2">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48"
                                                                        height="48" viewBox="0 0 48 48" fill="none">
                                                                        <g clip-path="url(#clip0_1853_1826)">
                                                                            <path fill-rule="evenodd"
                                                                                clip-rule="evenodd"
                                                                                d="M8.02 8C8.02 5.8 9.8 4 12 4H28L40 16V40C40 42.2 38.2 44 36 44H11.98C9.78 44 8 42.2 8 40L8.02 8ZM26 7V18H37L26 7ZM35.9674 34.1113H33.9166C33.9088 34.4316 33.8463 34.6953 33.7291 34.9023C33.6119 35.1055 33.4459 35.2578 33.2311 35.3594C33.0162 35.457 32.7525 35.5059 32.44 35.5059C32.1588 35.5059 31.9205 35.459 31.7252 35.3652C31.5338 35.2676 31.3775 35.1172 31.2564 34.9141C31.1354 34.7109 31.0475 34.4492 30.9928 34.1289C30.9381 33.8086 30.9107 33.4219 30.9107 32.9688V32.4941C30.9107 32.041 30.94 31.6543 30.9986 31.334C31.0611 31.0098 31.1549 30.7461 31.2799 30.543C31.4049 30.3398 31.5611 30.1914 31.7486 30.0977C31.9361 30.0039 32.1568 29.957 32.4107 29.957C32.774 29.957 33.065 30.0117 33.2838 30.1211C33.5025 30.2305 33.6627 30.3945 33.7643 30.6133C33.8658 30.8281 33.9205 31.0957 33.9283 31.416H35.9791C35.9283 30.8262 35.7623 30.3008 35.4811 29.8398C35.1998 29.375 34.8033 29.0098 34.2916 28.7441C33.7799 28.4785 33.1529 28.3457 32.4107 28.3457C31.8717 28.3457 31.3814 28.4414 30.94 28.6328C30.4986 28.8242 30.1197 29.1016 29.8033 29.4648C29.4908 29.8242 29.2486 30.2617 29.0768 30.7773C28.9088 31.2891 28.8248 31.8652 28.8248 32.5059V32.9688C28.8248 33.6094 28.9049 34.1855 29.065 34.6973C29.2291 35.209 29.4654 35.6445 29.774 36.0039C30.0865 36.3633 30.4654 36.6387 30.9107 36.8301C31.36 37.0215 31.8697 37.1172 32.44 37.1172C33.1432 37.1172 33.7525 36.9922 34.2682 36.7422C34.7877 36.4883 35.1939 36.1348 35.4869 35.6816C35.7799 35.2285 35.94 34.7051 35.9674 34.1113ZM27.9236 32.5645V32.9102C27.9236 33.5625 27.8318 34.1484 27.6482 34.668C27.4686 35.1836 27.2127 35.625 26.8807 35.9922C26.5486 36.3555 26.1561 36.6348 25.7029 36.8301C25.2498 37.0215 24.7498 37.1172 24.2029 37.1172C23.6521 37.1172 23.1482 37.0215 22.6912 36.8301C22.2381 36.6348 21.8436 36.3555 21.5076 35.9922C21.1756 35.625 20.9178 35.1836 20.7342 34.668C20.5545 34.1484 20.4646 33.5625 20.4646 32.9102V32.5645C20.4646 31.9121 20.5545 31.3262 20.7342 30.8066C20.9178 30.2871 21.1736 29.8457 21.5018 29.4824C21.8338 29.1152 22.2264 28.8359 22.6795 28.6445C23.1365 28.4492 23.6404 28.3516 24.1912 28.3516C24.7381 28.3516 25.2381 28.4492 25.6912 28.6445C26.1482 28.8359 26.5428 29.1152 26.8748 29.4824C27.2068 29.8457 27.4646 30.2871 27.6482 30.8066C27.8318 31.3262 27.9236 31.9121 27.9236 32.5645ZM25.8377 32.9102V32.5527C25.8377 32.1309 25.8006 31.7598 25.7264 31.4395C25.6561 31.1152 25.5506 30.8438 25.41 30.625C25.2693 30.4062 25.0955 30.2422 24.8885 30.1328C24.6854 30.0195 24.4529 29.9629 24.1912 29.9629C23.9178 29.9629 23.6795 30.0195 23.4764 30.1328C23.2732 30.2422 23.1033 30.4062 22.9666 30.625C22.8299 30.8438 22.7264 31.1152 22.6561 31.4395C22.5896 31.7598 22.5564 32.1309 22.5564 32.5527V32.9102C22.5564 33.3281 22.5896 33.6992 22.6561 34.0234C22.7264 34.3438 22.8299 34.6152 22.9666 34.8379C23.1072 35.0605 23.2791 35.2285 23.4822 35.3418C23.6893 35.4551 23.9295 35.5117 24.2029 35.5117C24.4646 35.5117 24.6971 35.4551 24.9002 35.3418C25.1033 35.2285 25.2732 35.0605 25.41 34.8379C25.5506 34.6152 25.6561 34.3438 25.7264 34.0234C25.8006 33.6992 25.8377 33.3281 25.8377 32.9102ZM14.917 37H15.6318C16.2021 37 16.7256 36.9023 17.2021 36.707C17.6826 36.5078 18.0986 36.2266 18.4502 35.8633C18.8018 35.5 19.0732 35.0684 19.2646 34.5684C19.46 34.0684 19.5576 33.5176 19.5576 32.916V32.5586C19.5576 31.9531 19.46 31.4023 19.2646 30.9062C19.0732 30.4062 18.7998 29.9746 18.4443 29.6113C18.0928 29.2441 17.6748 28.9629 17.1904 28.7676C16.71 28.5684 16.1807 28.4688 15.6025 28.4688H14.917H13.7041H12.8604V37H13.7393H14.917ZM14.917 35.418H15.6318C16.0225 35.418 16.3525 35.3242 16.6221 35.1367C16.8955 34.9492 17.1025 34.6699 17.2432 34.2988C17.3877 33.9238 17.46 33.4629 17.46 32.916V32.5469C17.46 32.1367 17.4189 31.7773 17.3369 31.4688C17.2588 31.1562 17.1416 30.8965 16.9854 30.6895C16.8291 30.4785 16.6338 30.3203 16.3994 30.2148C16.1689 30.1094 15.9033 30.0566 15.6025 30.0566H14.917V35.418Z"
                                                                                fill="#1A5ABC" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_1853_1826">
                                                                                <rect width="48" height="48"
                                                                                    fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </a>
                                                        <PhotoPreview v-model="isShowImageModal">
                                                            <template slot="content">
                                                                <img :src="ImageModalUrl" alt="ImgModal.title"
                                                                    style="object-fit: contain; max-height: 80vh; max-width: 80vw;" />
                                                            </template>
                                                        </PhotoPreview>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="productSourcingMatched-body-right">
                            <span class="productSourcingMatched-body-right-title">{{
                                $t("lbl_EMPBE_SalesLead_ContactInfo") }}</span>
                            <div class="productSourcingMatched-body-right-body">
                                <unlockToView v-if="showContactHiddenBanner" :no-quota="isContactHiddenNoQuota" />
                                <div class="productSourcingMatched-body-right-body-info-container">
                                    <div class="productSourcingMatched-body-right-body-info" v-if="buyerGradeId>0">
                                        <span class="productSourcingMatched-body-right-body-info-title"> {{$t("lbl_EMPBE_SalesLead_SourcingGradType") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">
                                            <svg v-if="isExhibitionBuyer" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M4.22461 4.22461C2.23361 6.21661 1 8.967 1 12C1 15.033 2.23361 17.7834 4.22461 19.7754L5.63867 18.3613C4.00867 16.7313 3 14.481 3 12C3 9.519 4.00867 7.26867 5.63867 5.63867L4.22461 4.22461ZM19.7754 4.22461L18.3613 5.63867C19.9913 7.26867 21 9.519 21 12C21 14.481 19.9913 16.7313 18.3613 18.3613L19.7754 19.7754C21.7664 17.7834 23 15.033 23 12C23 8.967 21.7664 6.21661 19.7754 4.22461ZM7.05273 7.05273C5.78473 8.31973 5 10.07 5 12C5 13.93 5.78473 15.6803 7.05273 16.9473L8.4668 15.5332C7.5608 14.6282 7 13.378 7 12C7 10.622 7.5618 9.3728 8.4668 8.4668L7.05273 7.05273ZM16.9473 7.05273L15.5332 8.4668C16.4392 9.3718 17 10.622 17 12C17 13.378 16.4382 14.6272 15.5332 15.5332L16.9473 16.9473C18.2143 15.6793 19 13.93 19 12C19 10.07 18.2153 8.31973 16.9473 7.05273ZM12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9Z"
                                                    fill="#FF000B" />
                                            </svg>
                                            <svg v-if="buyerGradeId==2"  xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M1.88821 11.7819C1.49296 11.5529 1.19124 11.2381 1.01536 10.8167C0.820622 10.3502 0.770206 9.86685 0.876811 9.3673C1.06539 8.48406 1.85627 7.99029 2.60481 7.95642C3.00775 7.93834 3.38068 8.03032 3.72628 8.2366C3.75861 8.25584 3.79324 8.27201 3.8275 8.28971C4.03493 8.15347 4.23198 8.00992 4.44249 7.88908C4.69227 7.74552 4.95358 7.62237 5.20913 7.48883C5.36807 7.4057 5.53125 7.32834 5.68173 7.23213C5.93689 7.06933 6.09506 6.83419 6.1501 6.534C6.1755 6.39545 6.1982 6.25613 6.21783 6.11643C6.27402 5.71387 6.49069 5.40406 6.78164 5.13736C7.12686 4.82139 7.54173 4.63435 7.99086 4.53622C8.42844 4.44116 8.87218 4.37111 9.31592 4.30877C10.3 4.17022 11.2833 4.02551 12.2424 3.75842C12.9847 3.55137 13.7102 3.29852 14.3833 2.91174C14.9052 2.61194 15.3847 2.26249 15.7488 1.77603C15.8442 1.64826 15.9227 1.50702 16.0039 1.36924C16.1101 1.18913 16.2422 1.11832 16.4123 1.15911C16.5847 1.20029 16.7063 1.36539 16.7098 1.5609C16.7128 1.72369 16.6412 1.86032 16.5512 1.98617C16.3095 2.32407 16.0624 2.65812 15.7161 2.95639C15.8242 2.92829 15.8992 2.91482 15.9697 2.88942C16.5997 2.66313 17.2105 2.39604 17.7419 1.98039C18.143 1.66635 18.4797 1.28727 18.7857 0.881631C18.8565 0.787727 18.9392 0.732308 19.0528 0.712295C19.3302 0.663803 19.5796 0.933587 19.4953 1.20222C19.4672 1.2915 19.4134 1.37617 19.3576 1.45314C19.025 1.91189 18.6579 2.33869 18.1922 2.67044C18.1676 2.68776 18.1472 2.71123 18.1056 2.74933C18.3092 2.78282 18.482 2.73086 18.6552 2.71239C19.2837 2.64504 19.8914 2.48378 20.4775 2.25249C20.9493 2.06622 21.4034 1.83992 21.7798 1.48624C21.8218 1.4466 21.8664 1.40965 21.9107 1.37271C22.1135 1.20337 22.2944 1.19336 22.5061 1.33884C22.6996 1.47238 22.7816 1.71215 22.6823 1.93306C22.6257 2.0589 22.5445 2.1836 22.4456 2.27866C22.2382 2.47801 22.0227 2.67275 21.7906 2.84208C21.2407 3.24233 20.6245 3.51173 19.9706 3.69338C19.209 3.90505 18.437 4.05515 17.6453 4.09633C16.926 4.13366 16.2194 4.25489 15.5244 4.44462C15.3885 4.48157 15.2488 4.50504 15.113 4.54199C14.9383 4.58971 14.8151 4.77483 14.8332 4.95109C14.8532 5.14814 15.0056 5.29938 15.1984 5.30747C15.2685 5.31054 15.3408 5.30824 15.4089 5.29361C15.8862 5.19086 16.3684 5.13544 16.856 5.10542C17.5103 5.06462 18.153 4.94532 18.776 4.73365C18.7995 4.72556 18.8249 4.72326 18.8576 4.7171C18.8892 4.80292 18.8334 4.85642 18.7957 4.90953C18.5444 5.26013 18.2603 5.58148 17.9197 5.84819C17.4152 6.24343 16.8664 6.55478 16.2429 6.72373C15.8138 6.83996 15.3828 6.92963 14.934 6.86844C14.8963 6.86344 14.8571 6.86421 14.8186 6.86459C14.5981 6.8669 14.4499 6.98697 14.4102 7.1948C14.3745 7.38299 14.4888 7.57927 14.6793 7.65123C14.7266 7.66932 14.7774 7.68279 14.8274 7.68895C16.1621 7.85174 17.4325 7.62776 18.6437 7.05048C18.6995 7.02392 18.7583 7.00314 18.8461 6.96696C18.8299 7.03239 18.8284 7.06933 18.8122 7.09858C18.2696 8.09112 17.4641 8.77732 16.4049 9.17372C15.8554 9.37923 15.2869 9.45505 14.7058 9.43388C14.366 9.42157 14.03 9.365 13.7106 9.23607C13.6809 9.22414 13.6505 9.21413 13.6201 9.20297C13.482 9.15178 13.3519 9.15871 13.2503 9.27571C13.1429 9.39925 13.0956 9.53933 13.1629 9.70251C13.2145 9.82721 13.3038 9.91534 13.4196 9.97884C13.955 10.2729 14.5126 10.5149 15.0976 10.6935C15.5968 10.8459 16.1075 10.9302 16.6266 10.9687C16.7159 10.9752 16.8044 10.9929 16.8929 11.0083C16.9091 11.011 16.9226 11.0268 16.9634 11.0541C16.9003 11.0965 16.8525 11.133 16.8006 11.1627C16.3441 11.4232 15.8511 11.5783 15.3366 11.6722C14.6573 11.7961 13.9754 11.8088 13.2872 11.7615C12.0988 11.6791 10.9654 11.3693 9.85202 10.9664C9.207 10.7328 8.56044 10.5057 7.88041 10.3887C7.13148 10.2598 6.38717 10.2386 5.65748 10.4865C5.43388 10.5627 5.21644 10.6623 5.00592 10.7709C4.58297 10.9891 4.14693 11.0584 3.6851 10.9271C3.41301 10.8498 3.14091 10.859 2.8669 10.9202C2.47011 11.0091 2.19302 11.2469 2.00713 11.601C1.98019 11.6518 1.95248 11.7026 1.92477 11.753C1.92208 11.758 1.91515 11.7611 1.88667 11.7834L1.88821 11.7819ZM2.69179 9.78833C2.83611 9.96537 3.01622 10.0874 3.23059 10.1451C3.49421 10.2159 3.76323 10.214 4.03185 10.1713C4.36052 10.1189 4.65186 9.97153 4.93973 9.81451C5.10291 9.7256 5.26685 9.63709 5.43619 9.5605C5.88647 9.35768 6.35599 9.30573 6.84553 9.37231C7.26887 9.43003 7.66989 9.56396 8.06591 9.7106C8.77558 9.97384 9.49718 10.1443 10.2615 10.1278C10.7772 10.1166 11.2679 10.0246 11.7317 9.80104C12.8658 9.25416 13.2522 8.33204 13.1818 7.2583C13.1722 7.10974 13.1133 6.9685 12.977 6.88268C12.7096 6.7145 12.3959 6.88614 12.3678 7.21866C12.3594 7.32026 12.3759 7.4234 12.3755 7.52577C12.3751 7.75091 12.3559 7.97105 12.2535 8.18003C12.0111 8.67456 11.6243 8.99707 11.1055 9.16679C10.6252 9.32382 10.1322 9.31843 9.63881 9.26301C9.10001 9.20259 8.58854 9.03286 8.08476 8.83813C7.6391 8.6661 7.17881 8.5518 6.70236 8.52332C5.98191 8.48021 5.30034 8.62184 4.67187 8.99168C4.48444 9.10214 4.28778 9.19758 4.09305 9.29572C3.80671 9.44004 3.53616 9.41811 3.2887 9.20605C3.06279 9.01247 2.80609 8.98553 2.53015 9.06712C2.22996 9.15602 2.03561 9.4539 2.08603 9.74485C2.12143 9.94882 2.30155 10.067 2.48166 9.98615C2.55593 9.95267 2.60789 9.86954 2.6914 9.78795L2.69179 9.78833ZM6.74662 7.40339C7.08414 7.44149 7.40165 7.50537 7.71261 7.6139C8.02819 7.72436 8.35339 7.79825 8.69245 7.77054C9.11926 7.7359 9.44523 7.5404 9.65189 7.16016C9.70693 7.05894 9.75696 6.95503 9.80815 6.85151C9.93592 6.59288 10.1087 6.37659 10.3658 6.2342C10.4609 6.18147 10.5505 6.11913 10.6429 6.06101C10.9208 5.88706 11.1809 5.69078 11.4084 5.45371C11.4357 5.42523 11.4538 5.38829 11.485 5.34249C11.4442 5.34249 11.4253 5.33902 11.408 5.34287C10.6136 5.52568 9.80584 5.60727 8.99533 5.68039C8.71092 5.70618 8.42729 5.77737 8.15211 5.85742C7.82614 5.9521 7.57368 6.15453 7.4205 6.46703C7.38664 6.53592 7.34469 6.60173 7.31659 6.67255C7.19921 6.97158 7.03103 7.22943 6.74701 7.40339H6.74662ZM18.3681 9.02671C18.7599 8.70304 19.0662 8.29587 19.3526 7.86406C19.5234 7.89677 19.6589 7.98452 19.7794 8.0842C20.8073 8.93511 21.5024 9.98461 21.7217 11.3239C21.7979 11.79 21.8202 12.2576 21.7791 12.7229C21.7002 13.62 21.4589 14.4736 21.0032 15.2587C20.1303 16.7635 18.8653 17.7775 17.1989 18.279C16.7263 18.4214 16.2406 18.5126 15.7476 18.5626C15.0449 18.6338 14.346 18.7274 13.6806 18.9814C13.0236 19.2319 12.4937 19.6429 12.1561 20.2683C11.9414 20.6667 11.8714 21.0996 11.9172 21.553C11.966 22.0375 12.1392 22.4728 12.4136 22.8696C12.4925 22.9839 12.5895 23.0859 12.6938 23.2129C12.5753 23.2163 12.4883 23.1786 12.4063 23.1405C11.4699 22.7033 10.9793 21.9567 10.9219 20.9349C10.8792 20.1737 11.1201 19.4875 11.6004 18.9021C11.9845 18.4337 12.4413 18.0423 12.9928 17.7691C13.5058 17.5151 14.0339 17.3053 14.5823 17.1418C15.3885 16.9016 16.1402 16.5437 16.8056 16.0272C17.7816 15.2698 18.452 14.3092 18.6683 13.0723C18.8122 12.2479 18.6983 11.4628 18.248 10.7435C18.0467 10.4222 17.7512 10.194 17.4491 9.97576C17.3875 9.93112 17.3236 9.88917 17.2382 9.83067C17.3132 9.76986 17.374 9.72022 17.4387 9.66749C17.5283 9.69212 17.6119 9.70521 17.6869 9.73715C18.4658 10.0693 19.1182 10.5642 19.5889 11.2739C19.8086 11.6049 19.9968 11.9585 20.0765 12.3545C20.108 12.5104 20.1157 12.6713 20.1357 12.8295C20.1469 12.918 20.1477 13.01 20.1746 13.0939C20.2335 13.277 20.382 13.3679 20.5745 13.3544C20.7646 13.3413 20.9051 13.2293 20.9228 13.033C20.9397 12.8437 20.9366 12.6486 20.9116 12.46C20.7661 11.3589 20.2277 10.4761 19.3976 9.75485C19.124 9.51701 18.8184 9.33228 18.5086 9.15102C18.4701 9.12831 18.4312 9.10599 18.3939 9.08097C18.385 9.07481 18.3827 9.05904 18.3673 9.02748L18.3681 9.02671ZM12.6361 17.0309C12.5818 16.994 12.5337 16.9624 12.4867 16.9297C11.9614 16.5622 11.371 16.4125 10.7399 16.449C10.2888 16.4752 9.87934 16.6538 9.51912 16.9251C9.14312 17.2083 8.83947 17.5605 8.72131 18.0258C8.63857 18.3514 8.55891 18.69 8.68398 19.0276C8.71208 19.103 8.75172 19.185 8.80983 19.2369C9.06345 19.4624 9.4256 19.3147 9.48602 18.9633C9.49872 18.889 9.49487 18.8093 9.48525 18.7335C9.43484 18.3237 9.60032 17.9923 9.87357 17.7113C9.98326 17.5986 10.1226 17.5066 10.263 17.4343C10.7757 17.1702 11.2775 17.226 11.7636 17.5147C11.7732 17.5205 11.7771 17.5351 11.7959 17.5651C11.7467 17.6063 11.6943 17.6498 11.6424 17.6936C10.868 18.3464 10.32 19.1399 10.1457 20.1548C10.0002 21.0019 10.1014 21.8151 10.5328 22.5725C10.5798 22.6548 10.6256 22.7383 10.6945 22.8619C10.3997 22.7768 10.1399 22.721 9.8982 22.6056C9.04498 22.1976 8.37879 21.5888 7.92851 20.7532C7.6545 20.2449 7.49093 19.703 7.44898 19.1242C7.40203 18.4741 7.49786 17.8522 7.72916 17.2407C7.93544 16.6949 8.25679 16.2377 8.65974 15.8244C9.17006 15.301 9.77659 14.9238 10.4424 14.641C10.8684 14.4601 11.3125 14.3304 11.7848 14.3462C11.8471 14.3481 11.9095 14.3539 11.9818 14.3585C11.9737 14.5209 11.8856 14.6175 11.7832 14.7041C11.7494 14.733 11.7082 14.7534 11.6701 14.7768C11.5331 14.8603 11.4888 14.9862 11.5054 15.139C11.5335 15.3995 11.8821 15.6439 12.1281 15.5596C12.272 15.5104 12.4109 15.4954 12.5599 15.5069C12.6938 15.5173 12.8289 15.5134 12.9636 15.5138C13.7614 15.5161 14.4483 15.2186 15.0695 14.7391C15.5667 14.355 15.8958 13.8528 16.1225 13.2744C16.2314 12.9965 16.2702 12.7048 16.3045 12.4119C16.3095 12.368 16.3164 12.3241 16.3203 12.2961C16.7925 12.0678 17.2516 11.8462 17.7315 11.6145C17.7539 11.6718 17.7835 11.733 17.8012 11.7977C17.9232 12.2395 17.9259 12.6821 17.8189 13.1285C17.6723 13.7416 17.3667 14.2646 16.9614 14.7422C16.3311 15.485 15.5225 15.9456 14.6204 16.2658C14.1308 16.4394 13.6386 16.6045 13.1514 16.7838C12.9786 16.8477 12.8169 16.9428 12.6357 17.0309H12.6361ZM6.234 14.7264C5.70174 14.8896 5.20027 14.7965 4.71651 14.584C4.22813 14.3697 3.86406 14.0044 3.55964 13.5468C3.49652 14.1591 3.70742 14.6679 4.05764 15.1809C3.96066 15.1548 3.91062 15.1494 3.86829 15.1286C3.1209 14.7626 2.58403 14.2219 2.43163 13.3713C2.35966 12.9688 2.41431 12.5782 2.59557 12.2106C2.75683 11.8835 3.21096 11.661 3.58581 11.7149C3.74437 11.7376 3.90293 11.7599 4.06072 11.7861C4.43326 11.8477 4.78694 11.7834 5.13023 11.6353C5.43581 11.5032 5.73869 11.362 6.05196 11.2512C6.46953 11.1034 6.90403 11.0968 7.34315 11.1388C7.84538 11.1869 8.33069 11.2935 8.79097 11.5006C9.31899 11.7376 9.72463 12.1036 9.96055 12.6409C9.99018 12.7082 10.0079 12.781 10.0179 12.8641C9.05575 12.2787 8.01395 12.0521 6.90826 12.1067C6.61154 12.1213 6.31097 12.1563 6.01655 12.2837C6.15587 12.6374 6.40141 12.8853 6.67658 13.1077C6.95791 13.3348 7.29889 13.4264 7.65142 13.5057C7.48247 13.6838 6.77202 13.8062 6.21552 13.7104C5.71483 13.6242 5.27532 13.426 4.89701 13.025C4.93665 13.4475 5.11253 13.7662 5.34844 14.0571C5.58628 14.3508 5.88647 14.5632 6.23361 14.726L6.234 14.7264ZM20.7515 7.76862C20.8562 7.58619 20.9566 7.41109 21.0648 7.22289C21.1298 7.26061 21.1814 7.28447 21.226 7.31756C22.1635 8.018 22.7839 8.9328 23.0676 10.0689C23.1434 10.3725 23.1853 10.6843 23.1719 11.001C23.1669 11.1226 23.1318 11.2262 23.0425 11.3104C22.8667 11.4763 22.6165 11.4305 22.5191 11.2092C22.4914 11.1461 22.4783 11.0745 22.4683 11.0052C22.3144 9.9188 21.841 8.98514 21.1144 8.17271C20.9955 8.03994 20.8762 7.90755 20.7515 7.76862ZM19.2109 5.914C19.3749 5.61881 19.5261 5.34672 19.6905 5.05154C19.8202 5.0704 19.9599 5.08079 20.0946 5.11234C20.7642 5.26975 21.4119 5.48681 22.0054 5.84511C22.3529 6.05524 22.6692 6.30386 22.9375 6.60982C22.9914 6.67139 23.0406 6.74259 23.0706 6.81764C23.1249 6.95388 23.0649 7.06702 22.9671 7.16247C22.8721 7.2556 22.7601 7.26215 22.6488 7.20211C22.5649 7.1567 22.4853 7.10128 22.4106 7.04124C21.9442 6.66601 21.4111 6.42355 20.8435 6.24805C20.3532 6.09642 19.8529 5.99443 19.3429 5.93863C19.3056 5.9344 19.269 5.92516 19.2113 5.914H19.2109ZM12.7681 14.681C13.1425 14.0179 13.1233 13.3321 13.0317 12.6328H13.3838C13.3877 12.7386 13.3865 12.8268 13.3954 12.9134C13.4069 13.0273 13.4115 13.1447 13.4454 13.2524C13.5312 13.5222 13.94 13.6192 14.1339 13.3667C14.2244 13.249 14.2655 13.1196 14.2667 12.9746C14.2675 12.8733 14.2667 12.7717 14.2667 12.6463C14.6573 12.6028 15.0276 12.5616 15.4124 12.5185C15.417 12.5739 15.4301 12.6182 15.4224 12.6578C15.3239 13.1651 15.088 13.5972 14.6985 13.939C14.5546 14.0656 14.4014 14.183 14.2448 14.2938C13.843 14.5775 13.3792 14.6664 12.9008 14.7022C12.8708 14.7045 12.8396 14.6929 12.7681 14.6814V14.681ZM9.44561 6.36312C8.8995 6.33888 8.15442 6.60212 7.78073 6.95157C8.36032 7.37298 9.04844 7.12976 9.44561 6.36312Z"
                                                    fill="#DD8700" />
                                            </svg>
                                            <svg v-if="buyerGradeId==3"  xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_1916_11)">
                                                    <path
                                                        d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"
                                                        fill="#51BB25" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1916_11">
                                                        <rect width="24" height="24" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            {{$t("lbl_EMPBE_SalesLead_SourcingGradType_"+buyerGradeId) }}
                                        </span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_ReportAll_Table_CompanyName") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactcompany
                                            }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Name") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactName }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t('lbl_EMPBE_CountryOrArea') }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{ countryName
                                        }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Mobile") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactNumber }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t('Lbl_EmailAddress') }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactEmail }}</span>
                                    </div>

                                </div>
                                <span class="productSourcingMatched-body-right-body-text" v-html="GetContactTips"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="productSourcingMatched-remarks" v-if="!mobile && messageBoardSourceId > 0">
                <MessageThread
                    :key="'remarks-sourcing-' + messageBoardSourceType + '-' + messageBoardSourceId"
                    :source-type="messageBoardSourceType"
                    :source-id="messageBoardSourceId"
                    log-form-type-prefix="SalesleadBack_"
                    :simulated-supplier="!!simulatedSupplier"
                    :max-depth="5"
                    :allow-create="true"
                    :allow-reply="false"
                    :allow-delete="false"
                    :root-level-only="true"
                />
            </div>
        <div class="productSourcingMatched-container" v-if="mobile">
            <div class="productSourcingMatched-detail">
                <div class="productSourcingMatched-header-container">
                    <i @click="$emit('close')" style="width: 24px; height: 24px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <g clip-path="url(#clip0_1529_44546)">
                                <path d="M15.41 17.09L10.83 12.5L15.41 7.91L14 6.5L8 12.5L14 18.5L15.41 17.09Z"
                                    fill="black" fill-opacity="0.6" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1529_44546">
                                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                    <div class="productSourcingMatched-header">
                        <div class="productSourcingMatched-title">
                            <span class="productSourcingMatched-title-name">{{ title }}</span>
                            <div class="productSourcingMatched-title-unread" v-if="unread">{{
                                $t("lbl_EMPBE_SalesLead_Unread") }}</div>
                            <span class="productSourcingMatched-title-viewed" :class="{ 'is-unlocked': isQuotaUnlocked }" v-else-if="viewedOnText">
                            <img
                                v-if="isQuotaUnlocked"
                                class="productSourcingMatched-title-viewed__lock"
                                :src="unlockedChipLockImg"
                                width="15"
                                height="16"
                                alt=""
                            />
                            <span>{{ viewedOnText }}</span>
                        </span>
                        </div>
                        <div class="productSourcingMatched-subtitle">
                            <span class="productSourcingMatched-subtitle-date"> {{
                                GetDate()
                            }}</span>
                            <TipsAndPrivewDilog
                                v-if="visibilityTipText && simulatedSupplier"
                                class="productSourcingMatched-visibility-tip"
                                :id="`SalesLead_Sourcing_VisibilityTip_m_${rid || 0}`"
                                :Title="visibilityTipText"
                            >
                                <template v-slot:Text></template>
                            </TipsAndPrivewDilog>
                            <span class="productSourcingMatched-subtitle-unicode" v-html="GetCodeText"></span>

                        </div>
                    </div>
                </div>
                <div class="productSourcingMatched-unLock" v-if="showUnlockBanner" v-show="isContactLocked">
                    <unlockQuota_Free
                        Type="2"
                        unlockType="SourcingRequest"
                        :user="user"
                        :rid="rid"
                        :mobile="mobile"
                        :simulatedSupplier="simulatedSupplier"
                        @unlockQuota="onUnlockQuota"
                        @unlockQuotaInfo="onUnlockQuotaInfo"
                    />
                </div>
                <div class="productSourcingMatched-body-container">
                    <div class="productSourcingMatched-body">
                        <div class="productSourcingMatched-body-left">
                            <div class="productSourcingMatched-body-left-Title">
                                <div class="productSourcingMatched-body-left-header">{{
                                    $t("lbl_EMPBE_SalesLead_DetailsSourcingRequest") }}</div>
                                <div class="productSourcingMatched-body-left-header-Date">{{ ObjData.sourcingRequestDate
                                }}</div>
                            </div>
                            <div
                                class="productSourcingMatched-exhibition-banner"
                                v-if="isExhibitionBuyer"
                            >
                                <img
                                    class="productSourcingMatched-exhibition-banner__icon"
                                    src="https://cdn.adsalecdn.com/EMP/Backend/Images/light_bulb.svg"
                                    alt=""
                                    width="20"
                                    height="20"
                                />
                                <div
                                    class="productSourcingMatched-exhibition-banner__text"
                                    v-html="$t('lbl_EMPBE_SalesLead_ExhibitionTips')"
                                ></div>
                            </div>
                            <div class="productSourcingMatched-body-left-requirment-container">
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.content">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_LookingForProduct") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.content }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.productDesc">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_ProductPropertiesAndOtherRequirements") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.productDesc }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.natureText">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingNature") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail natureText"> {{
                                            ObjData.natureText }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment" v-if="ObjData.catsName">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingCategory") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.catsName }}</span>
                                    </div>
                                </div>
                                <div class="productSourcingMatched-body-left-requirment"
                                    v-if="ObjData.productTargetQuantity">
                                    <span class="productSourcingMatched-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingRequestQuantity") }}</span>
                                    <div class="productSourcingMatched-body-left-requirment-detail-container">
                                        <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                            ObjData.productTargetQuantity }}</span>
                                    </div>
                                </div>
                            </div>

                            <!--贵司的回复-->
                            <div v-if="SalesLeadType == 1" class="productSourcingMatched-body-left-ContactBuyer">
                                <div class="productSourcingMatched-body-left-ContactBuyer-Svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="311" viewBox="0 0 17 311"
                                        fill="none">
                                        <path d="M1 0V294C1 302.837 8.16344 310 17 310V310" stroke="black"
                                            stroke-opacity="0.1" />
                                    </svg>
                                </div>
                                <div class="productSourcingMatched-body-left-ContactBuyer-Nav">
                                    <div class="productSourcingMatched-body-left-Title">
                                        <div class="productSourcingMatched-body-left-header">
                                            {{ $t("lbl_EMPBE_SalesLead_YourReply") }}</div>
                                        <div class="productSourcingMatched-body-left-header-Date">{{
                                            ObjData.contactBuyerDate }}</div>
                                    </div>

                                    <div class="productSourcingMatched-body-left-requirment-container">
                                        <div class="productSourcingMatched-body-left-requirment">
                                            <span class="productSourcingMatched-body-left-requirment-title">{{
                                                $t("lbl_EMPBE_SalesLead_YourReply_Content") }}</span>
                                            <div class="productSourcingMatched-body-left-requirment-detail-container">
                                                <span class="productSourcingMatched-body-left-requirment-detail"> {{
                                                    ObjData.contactBuyerContent }}</span>
                                            </div>
                                        </div>
                                        <div class="productSourcingMatched-body-left-requirment">
                                            <span class="productSourcingMatched-body-left-requirment-title">{{
                                                $t("lbl_EMPBE_SalesLead_YourReply_Url") }}</span>
                                            <div class="productSourcingMatched-body-left-requirment-detail-container">
                                                <span class="productSourcingMatched-body-left-requirment-detail"><a
                                                        v-if="ObjData.productUrl"
                                                        target="_blank"
                                                        :href="GetContactBuyerUrl">{{
                                                            ObjData.productUrl }}</a></span>
                                            </div>
                                        </div>
                                        <div class="productSourcingMatched-body-left-requirment">
                                            <span class="productSourcingMatched-body-left-requirment-title">{{$t("lbl_EMPBE_SalesLead_PictureCatalogue")}}</span>
                                            <div class="productSourcingMatched-body-left-requirment-detail-container">
                                                <div class="productSourcingMatched-body-left-requirment-detail">
                                                    <div class="file-BG">
                                                        <a v-for="(item, index) in GetContactBuyerFiles" :key="index"
                                                            :href="GetFileType(item.FileName) != 0 ? item.FileName : 'javaScript:;'">
                                                            <div class="file-Bg-Nav">
                                                                <img class="ContactBuyerPhoto"
                                                                    @click="ShowImgModel(item.FileName)"
                                                                    v-if="GetFileType(item.FileName) == 0"
                                                                    :src="item.FileName" />
                                                                <span class="" v-if="GetFileType(item.FileName) == 1">

                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48"
                                                                        height="48" viewBox="0 0 48 48" fill="none">
                                                                        <g clip-path="url(#clip0_1853_1813)">
                                                                            <path fill-rule="evenodd"
                                                                                clip-rule="evenodd"
                                                                                d="M8.02 8C8.02 5.8 9.8 4 12 4H28L40 16V40C40 42.2 38.2 44 36 44H11.98C9.78 44 8 42.2 8 40L8.02 8ZM26 7V18H37L26 7ZM31.5436 32.0195V30.0566H35.1939V28.4688H31.5436H30.9576H29.4869V37H31.5436V33.6016H34.86V32.0195H31.5436ZM24.4139 37H23.699H22.5213H21.6424V28.4688H22.4861H23.699H24.3846C24.9627 28.4688 25.492 28.5684 25.9725 28.7676C26.4568 28.9629 26.8748 29.2441 27.2264 29.6113C27.5818 29.9746 27.8553 30.4062 28.0467 30.9062C28.242 31.4023 28.3396 31.9531 28.3396 32.5586V32.916C28.3396 33.5176 28.242 34.0684 28.0467 34.5684C27.8553 35.0684 27.5838 35.5 27.2322 35.8633C26.8807 36.2266 26.4646 36.5078 25.9842 36.707C25.5076 36.9023 24.9842 37 24.4139 37ZM24.4139 35.418H23.699V30.0566H24.3846C24.6854 30.0566 24.951 30.1094 25.1814 30.2148C25.4158 30.3203 25.6111 30.4785 25.7674 30.6895C25.9236 30.8965 26.0408 31.1562 26.1189 31.4688C26.201 31.7773 26.242 32.1367 26.242 32.5469V32.916C26.242 33.4629 26.1697 33.9238 26.0252 34.2988C25.8846 34.6699 25.6775 34.9492 25.4041 35.1367C25.1346 35.3242 24.8045 35.418 24.4139 35.418ZM15.8076 34.1055H17.1553C17.8389 34.1055 18.4268 33.9922 18.9189 33.7656C19.415 33.5352 19.7959 33.2148 20.0615 32.8047C20.3271 32.3945 20.46 31.9141 20.46 31.3633C20.46 30.8047 20.3271 30.3086 20.0615 29.875C19.7959 29.4375 19.415 29.0938 18.9189 28.8438C18.4268 28.5938 17.8389 28.4688 17.1553 28.4688H13.751V37H15.8076V34.1055ZM15.8076 32.5176V30.0566H17.1553C17.4443 30.0566 17.6787 30.1191 17.8584 30.2441C18.0381 30.3652 18.1689 30.5254 18.251 30.7246C18.3369 30.9238 18.3799 31.1406 18.3799 31.375C18.3799 31.5938 18.3369 31.791 18.251 31.9668C18.1689 32.1387 18.0381 32.2734 17.8584 32.3711C17.6787 32.4688 17.4443 32.5176 17.1553 32.5176H15.8076Z"
                                                                                fill="#E92425" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_1853_1813">
                                                                                <rect width="48" height="48"
                                                                                    fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                                <span class="" v-if="GetFileType(item.FileName) == 2">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48"
                                                                        height="48" viewBox="0 0 48 48" fill="none">
                                                                        <g clip-path="url(#clip0_1853_1826)">
                                                                            <path fill-rule="evenodd"
                                                                                clip-rule="evenodd"
                                                                                d="M8.02 8C8.02 5.8 9.8 4 12 4H28L40 16V40C40 42.2 38.2 44 36 44H11.98C9.78 44 8 42.2 8 40L8.02 8ZM26 7V18H37L26 7ZM35.9674 34.1113H33.9166C33.9088 34.4316 33.8463 34.6953 33.7291 34.9023C33.6119 35.1055 33.4459 35.2578 33.2311 35.3594C33.0162 35.457 32.7525 35.5059 32.44 35.5059C32.1588 35.5059 31.9205 35.459 31.7252 35.3652C31.5338 35.2676 31.3775 35.1172 31.2564 34.9141C31.1354 34.7109 31.0475 34.4492 30.9928 34.1289C30.9381 33.8086 30.9107 33.4219 30.9107 32.9688V32.4941C30.9107 32.041 30.94 31.6543 30.9986 31.334C31.0611 31.0098 31.1549 30.7461 31.2799 30.543C31.4049 30.3398 31.5611 30.1914 31.7486 30.0977C31.9361 30.0039 32.1568 29.957 32.4107 29.957C32.774 29.957 33.065 30.0117 33.2838 30.1211C33.5025 30.2305 33.6627 30.3945 33.7643 30.6133C33.8658 30.8281 33.9205 31.0957 33.9283 31.416H35.9791C35.9283 30.8262 35.7623 30.3008 35.4811 29.8398C35.1998 29.375 34.8033 29.0098 34.2916 28.7441C33.7799 28.4785 33.1529 28.3457 32.4107 28.3457C31.8717 28.3457 31.3814 28.4414 30.94 28.6328C30.4986 28.8242 30.1197 29.1016 29.8033 29.4648C29.4908 29.8242 29.2486 30.2617 29.0768 30.7773C28.9088 31.2891 28.8248 31.8652 28.8248 32.5059V32.9688C28.8248 33.6094 28.9049 34.1855 29.065 34.6973C29.2291 35.209 29.4654 35.6445 29.774 36.0039C30.0865 36.3633 30.4654 36.6387 30.9107 36.8301C31.36 37.0215 31.8697 37.1172 32.44 37.1172C33.1432 37.1172 33.7525 36.9922 34.2682 36.7422C34.7877 36.4883 35.1939 36.1348 35.4869 35.6816C35.7799 35.2285 35.94 34.7051 35.9674 34.1113ZM27.9236 32.5645V32.9102C27.9236 33.5625 27.8318 34.1484 27.6482 34.668C27.4686 35.1836 27.2127 35.625 26.8807 35.9922C26.5486 36.3555 26.1561 36.6348 25.7029 36.8301C25.2498 37.0215 24.7498 37.1172 24.2029 37.1172C23.6521 37.1172 23.1482 37.0215 22.6912 36.8301C22.2381 36.6348 21.8436 36.3555 21.5076 35.9922C21.1756 35.625 20.9178 35.1836 20.7342 34.668C20.5545 34.1484 20.4646 33.5625 20.4646 32.9102V32.5645C20.4646 31.9121 20.5545 31.3262 20.7342 30.8066C20.9178 30.2871 21.1736 29.8457 21.5018 29.4824C21.8338 29.1152 22.2264 28.8359 22.6795 28.6445C23.1365 28.4492 23.6404 28.3516 24.1912 28.3516C24.7381 28.3516 25.2381 28.4492 25.6912 28.6445C26.1482 28.8359 26.5428 29.1152 26.8748 29.4824C27.2068 29.8457 27.4646 30.2871 27.6482 30.8066C27.8318 31.3262 27.9236 31.9121 27.9236 32.5645ZM25.8377 32.9102V32.5527C25.8377 32.1309 25.8006 31.7598 25.7264 31.4395C25.6561 31.1152 25.5506 30.8438 25.41 30.625C25.2693 30.4062 25.0955 30.2422 24.8885 30.1328C24.6854 30.0195 24.4529 29.9629 24.1912 29.9629C23.9178 29.9629 23.6795 30.0195 23.4764 30.1328C23.2732 30.2422 23.1033 30.4062 22.9666 30.625C22.8299 30.8438 22.7264 31.1152 22.6561 31.4395C22.5896 31.7598 22.5564 32.1309 22.5564 32.5527V32.9102C22.5564 33.3281 22.5896 33.6992 22.6561 34.0234C22.7264 34.3438 22.8299 34.6152 22.9666 34.8379C23.1072 35.0605 23.2791 35.2285 23.4822 35.3418C23.6893 35.4551 23.9295 35.5117 24.2029 35.5117C24.4646 35.5117 24.6971 35.4551 24.9002 35.3418C25.1033 35.2285 25.2732 35.0605 25.41 34.8379C25.5506 34.6152 25.6561 34.3438 25.7264 34.0234C25.8006 33.6992 25.8377 33.3281 25.8377 32.9102ZM14.917 37H15.6318C16.2021 37 16.7256 36.9023 17.2021 36.707C17.6826 36.5078 18.0986 36.2266 18.4502 35.8633C18.8018 35.5 19.0732 35.0684 19.2646 34.5684C19.46 34.0684 19.5576 33.5176 19.5576 32.916V32.5586C19.5576 31.9531 19.46 31.4023 19.2646 30.9062C19.0732 30.4062 18.7998 29.9746 18.4443 29.6113C18.0928 29.2441 17.6748 28.9629 17.1904 28.7676C16.71 28.5684 16.1807 28.4688 15.6025 28.4688H14.917H13.7041H12.8604V37H13.7393H14.917ZM14.917 35.418H15.6318C16.0225 35.418 16.3525 35.3242 16.6221 35.1367C16.8955 34.9492 17.1025 34.6699 17.2432 34.2988C17.3877 33.9238 17.46 33.4629 17.46 32.916V32.5469C17.46 32.1367 17.4189 31.7773 17.3369 31.4688C17.2588 31.1562 17.1416 30.8965 16.9854 30.6895C16.8291 30.4785 16.6338 30.3203 16.3994 30.2148C16.1689 30.1094 15.9033 30.0566 15.6025 30.0566H14.917V35.418Z"
                                                                                fill="#1A5ABC" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_1853_1826">
                                                                                <rect width="48" height="48"
                                                                                    fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </a>
                                                        <PhotoPreview v-model="isShowImageModal">
                                                            <template slot="content">
                                                                <img :src="ImageModalUrl" alt="ImgModal.title"
                                                                    style="object-fit: contain; max-height: 80vh; max-width: 80vw;" />
                                                            </template>
                                                        </PhotoPreview>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="productSourcingMatched-body-right">
                            <span class="productSourcingMatched-body-right-title">{{
                                $t("lbl_EMPBE_SalesLead_ContactInfo") }}</span>
                            <div class="productSourcingMatched-body-right-body">
                                <unlockToView v-if="showContactHiddenBanner" :no-quota="isContactHiddenNoQuota" />
                                <div class="productSourcingMatched-body-right-body-info-container">
                                    <div class="productSourcingMatched-body-right-body-info" v-if="buyerGradeId>0">
                                        <span class="productSourcingMatched-body-right-body-info-title"> {{$t("lbl_EMPBE_SalesLead_SourcingGradType") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">
                                            <svg v-if="isExhibitionBuyer" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M4.22461 4.22461C2.23361 6.21661 1 8.967 1 12C1 15.033 2.23361 17.7834 4.22461 19.7754L5.63867 18.3613C4.00867 16.7313 3 14.481 3 12C3 9.519 4.00867 7.26867 5.63867 5.63867L4.22461 4.22461ZM19.7754 4.22461L18.3613 5.63867C19.9913 7.26867 21 9.519 21 12C21 14.481 19.9913 16.7313 18.3613 18.3613L19.7754 19.7754C21.7664 17.7834 23 15.033 23 12C23 8.967 21.7664 6.21661 19.7754 4.22461ZM7.05273 7.05273C5.78473 8.31973 5 10.07 5 12C5 13.93 5.78473 15.6803 7.05273 16.9473L8.4668 15.5332C7.5608 14.6282 7 13.378 7 12C7 10.622 7.5618 9.3728 8.4668 8.4668L7.05273 7.05273ZM16.9473 7.05273L15.5332 8.4668C16.4392 9.3718 17 10.622 17 12C17 13.378 16.4382 14.6272 15.5332 15.5332L16.9473 16.9473C18.2143 15.6793 19 13.93 19 12C19 10.07 18.2153 8.31973 16.9473 7.05273ZM12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9Z"
                                                    fill="#FF000B" />
                                            </svg>
                                            <svg v-if="buyerGradeId==2"  xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M1.88821 11.7819C1.49296 11.5529 1.19124 11.2381 1.01536 10.8167C0.820622 10.3502 0.770206 9.86685 0.876811 9.3673C1.06539 8.48406 1.85627 7.99029 2.60481 7.95642C3.00775 7.93834 3.38068 8.03032 3.72628 8.2366C3.75861 8.25584 3.79324 8.27201 3.8275 8.28971C4.03493 8.15347 4.23198 8.00992 4.44249 7.88908C4.69227 7.74552 4.95358 7.62237 5.20913 7.48883C5.36807 7.4057 5.53125 7.32834 5.68173 7.23213C5.93689 7.06933 6.09506 6.83419 6.1501 6.534C6.1755 6.39545 6.1982 6.25613 6.21783 6.11643C6.27402 5.71387 6.49069 5.40406 6.78164 5.13736C7.12686 4.82139 7.54173 4.63435 7.99086 4.53622C8.42844 4.44116 8.87218 4.37111 9.31592 4.30877C10.3 4.17022 11.2833 4.02551 12.2424 3.75842C12.9847 3.55137 13.7102 3.29852 14.3833 2.91174C14.9052 2.61194 15.3847 2.26249 15.7488 1.77603C15.8442 1.64826 15.9227 1.50702 16.0039 1.36924C16.1101 1.18913 16.2422 1.11832 16.4123 1.15911C16.5847 1.20029 16.7063 1.36539 16.7098 1.5609C16.7128 1.72369 16.6412 1.86032 16.5512 1.98617C16.3095 2.32407 16.0624 2.65812 15.7161 2.95639C15.8242 2.92829 15.8992 2.91482 15.9697 2.88942C16.5997 2.66313 17.2105 2.39604 17.7419 1.98039C18.143 1.66635 18.4797 1.28727 18.7857 0.881631C18.8565 0.787727 18.9392 0.732308 19.0528 0.712295C19.3302 0.663803 19.5796 0.933587 19.4953 1.20222C19.4672 1.2915 19.4134 1.37617 19.3576 1.45314C19.025 1.91189 18.6579 2.33869 18.1922 2.67044C18.1676 2.68776 18.1472 2.71123 18.1056 2.74933C18.3092 2.78282 18.482 2.73086 18.6552 2.71239C19.2837 2.64504 19.8914 2.48378 20.4775 2.25249C20.9493 2.06622 21.4034 1.83992 21.7798 1.48624C21.8218 1.4466 21.8664 1.40965 21.9107 1.37271C22.1135 1.20337 22.2944 1.19336 22.5061 1.33884C22.6996 1.47238 22.7816 1.71215 22.6823 1.93306C22.6257 2.0589 22.5445 2.1836 22.4456 2.27866C22.2382 2.47801 22.0227 2.67275 21.7906 2.84208C21.2407 3.24233 20.6245 3.51173 19.9706 3.69338C19.209 3.90505 18.437 4.05515 17.6453 4.09633C16.926 4.13366 16.2194 4.25489 15.5244 4.44462C15.3885 4.48157 15.2488 4.50504 15.113 4.54199C14.9383 4.58971 14.8151 4.77483 14.8332 4.95109C14.8532 5.14814 15.0056 5.29938 15.1984 5.30747C15.2685 5.31054 15.3408 5.30824 15.4089 5.29361C15.8862 5.19086 16.3684 5.13544 16.856 5.10542C17.5103 5.06462 18.153 4.94532 18.776 4.73365C18.7995 4.72556 18.8249 4.72326 18.8576 4.7171C18.8892 4.80292 18.8334 4.85642 18.7957 4.90953C18.5444 5.26013 18.2603 5.58148 17.9197 5.84819C17.4152 6.24343 16.8664 6.55478 16.2429 6.72373C15.8138 6.83996 15.3828 6.92963 14.934 6.86844C14.8963 6.86344 14.8571 6.86421 14.8186 6.86459C14.5981 6.8669 14.4499 6.98697 14.4102 7.1948C14.3745 7.38299 14.4888 7.57927 14.6793 7.65123C14.7266 7.66932 14.7774 7.68279 14.8274 7.68895C16.1621 7.85174 17.4325 7.62776 18.6437 7.05048C18.6995 7.02392 18.7583 7.00314 18.8461 6.96696C18.8299 7.03239 18.8284 7.06933 18.8122 7.09858C18.2696 8.09112 17.4641 8.77732 16.4049 9.17372C15.8554 9.37923 15.2869 9.45505 14.7058 9.43388C14.366 9.42157 14.03 9.365 13.7106 9.23607C13.6809 9.22414 13.6505 9.21413 13.6201 9.20297C13.482 9.15178 13.3519 9.15871 13.2503 9.27571C13.1429 9.39925 13.0956 9.53933 13.1629 9.70251C13.2145 9.82721 13.3038 9.91534 13.4196 9.97884C13.955 10.2729 14.5126 10.5149 15.0976 10.6935C15.5968 10.8459 16.1075 10.9302 16.6266 10.9687C16.7159 10.9752 16.8044 10.9929 16.8929 11.0083C16.9091 11.011 16.9226 11.0268 16.9634 11.0541C16.9003 11.0965 16.8525 11.133 16.8006 11.1627C16.3441 11.4232 15.8511 11.5783 15.3366 11.6722C14.6573 11.7961 13.9754 11.8088 13.2872 11.7615C12.0988 11.6791 10.9654 11.3693 9.85202 10.9664C9.207 10.7328 8.56044 10.5057 7.88041 10.3887C7.13148 10.2598 6.38717 10.2386 5.65748 10.4865C5.43388 10.5627 5.21644 10.6623 5.00592 10.7709C4.58297 10.9891 4.14693 11.0584 3.6851 10.9271C3.41301 10.8498 3.14091 10.859 2.8669 10.9202C2.47011 11.0091 2.19302 11.2469 2.00713 11.601C1.98019 11.6518 1.95248 11.7026 1.92477 11.753C1.92208 11.758 1.91515 11.7611 1.88667 11.7834L1.88821 11.7819ZM2.69179 9.78833C2.83611 9.96537 3.01622 10.0874 3.23059 10.1451C3.49421 10.2159 3.76323 10.214 4.03185 10.1713C4.36052 10.1189 4.65186 9.97153 4.93973 9.81451C5.10291 9.7256 5.26685 9.63709 5.43619 9.5605C5.88647 9.35768 6.35599 9.30573 6.84553 9.37231C7.26887 9.43003 7.66989 9.56396 8.06591 9.7106C8.77558 9.97384 9.49718 10.1443 10.2615 10.1278C10.7772 10.1166 11.2679 10.0246 11.7317 9.80104C12.8658 9.25416 13.2522 8.33204 13.1818 7.2583C13.1722 7.10974 13.1133 6.9685 12.977 6.88268C12.7096 6.7145 12.3959 6.88614 12.3678 7.21866C12.3594 7.32026 12.3759 7.4234 12.3755 7.52577C12.3751 7.75091 12.3559 7.97105 12.2535 8.18003C12.0111 8.67456 11.6243 8.99707 11.1055 9.16679C10.6252 9.32382 10.1322 9.31843 9.63881 9.26301C9.10001 9.20259 8.58854 9.03286 8.08476 8.83813C7.6391 8.6661 7.17881 8.5518 6.70236 8.52332C5.98191 8.48021 5.30034 8.62184 4.67187 8.99168C4.48444 9.10214 4.28778 9.19758 4.09305 9.29572C3.80671 9.44004 3.53616 9.41811 3.2887 9.20605C3.06279 9.01247 2.80609 8.98553 2.53015 9.06712C2.22996 9.15602 2.03561 9.4539 2.08603 9.74485C2.12143 9.94882 2.30155 10.067 2.48166 9.98615C2.55593 9.95267 2.60789 9.86954 2.6914 9.78795L2.69179 9.78833ZM6.74662 7.40339C7.08414 7.44149 7.40165 7.50537 7.71261 7.6139C8.02819 7.72436 8.35339 7.79825 8.69245 7.77054C9.11926 7.7359 9.44523 7.5404 9.65189 7.16016C9.70693 7.05894 9.75696 6.95503 9.80815 6.85151C9.93592 6.59288 10.1087 6.37659 10.3658 6.2342C10.4609 6.18147 10.5505 6.11913 10.6429 6.06101C10.9208 5.88706 11.1809 5.69078 11.4084 5.45371C11.4357 5.42523 11.4538 5.38829 11.485 5.34249C11.4442 5.34249 11.4253 5.33902 11.408 5.34287C10.6136 5.52568 9.80584 5.60727 8.99533 5.68039C8.71092 5.70618 8.42729 5.77737 8.15211 5.85742C7.82614 5.9521 7.57368 6.15453 7.4205 6.46703C7.38664 6.53592 7.34469 6.60173 7.31659 6.67255C7.19921 6.97158 7.03103 7.22943 6.74701 7.40339H6.74662ZM18.3681 9.02671C18.7599 8.70304 19.0662 8.29587 19.3526 7.86406C19.5234 7.89677 19.6589 7.98452 19.7794 8.0842C20.8073 8.93511 21.5024 9.98461 21.7217 11.3239C21.7979 11.79 21.8202 12.2576 21.7791 12.7229C21.7002 13.62 21.4589 14.4736 21.0032 15.2587C20.1303 16.7635 18.8653 17.7775 17.1989 18.279C16.7263 18.4214 16.2406 18.5126 15.7476 18.5626C15.0449 18.6338 14.346 18.7274 13.6806 18.9814C13.0236 19.2319 12.4937 19.6429 12.1561 20.2683C11.9414 20.6667 11.8714 21.0996 11.9172 21.553C11.966 22.0375 12.1392 22.4728 12.4136 22.8696C12.4925 22.9839 12.5895 23.0859 12.6938 23.2129C12.5753 23.2163 12.4883 23.1786 12.4063 23.1405C11.4699 22.7033 10.9793 21.9567 10.9219 20.9349C10.8792 20.1737 11.1201 19.4875 11.6004 18.9021C11.9845 18.4337 12.4413 18.0423 12.9928 17.7691C13.5058 17.5151 14.0339 17.3053 14.5823 17.1418C15.3885 16.9016 16.1402 16.5437 16.8056 16.0272C17.7816 15.2698 18.452 14.3092 18.6683 13.0723C18.8122 12.2479 18.6983 11.4628 18.248 10.7435C18.0467 10.4222 17.7512 10.194 17.4491 9.97576C17.3875 9.93112 17.3236 9.88917 17.2382 9.83067C17.3132 9.76986 17.374 9.72022 17.4387 9.66749C17.5283 9.69212 17.6119 9.70521 17.6869 9.73715C18.4658 10.0693 19.1182 10.5642 19.5889 11.2739C19.8086 11.6049 19.9968 11.9585 20.0765 12.3545C20.108 12.5104 20.1157 12.6713 20.1357 12.8295C20.1469 12.918 20.1477 13.01 20.1746 13.0939C20.2335 13.277 20.382 13.3679 20.5745 13.3544C20.7646 13.3413 20.9051 13.2293 20.9228 13.033C20.9397 12.8437 20.9366 12.6486 20.9116 12.46C20.7661 11.3589 20.2277 10.4761 19.3976 9.75485C19.124 9.51701 18.8184 9.33228 18.5086 9.15102C18.4701 9.12831 18.4312 9.10599 18.3939 9.08097C18.385 9.07481 18.3827 9.05904 18.3673 9.02748L18.3681 9.02671ZM12.6361 17.0309C12.5818 16.994 12.5337 16.9624 12.4867 16.9297C11.9614 16.5622 11.371 16.4125 10.7399 16.449C10.2888 16.4752 9.87934 16.6538 9.51912 16.9251C9.14312 17.2083 8.83947 17.5605 8.72131 18.0258C8.63857 18.3514 8.55891 18.69 8.68398 19.0276C8.71208 19.103 8.75172 19.185 8.80983 19.2369C9.06345 19.4624 9.4256 19.3147 9.48602 18.9633C9.49872 18.889 9.49487 18.8093 9.48525 18.7335C9.43484 18.3237 9.60032 17.9923 9.87357 17.7113C9.98326 17.5986 10.1226 17.5066 10.263 17.4343C10.7757 17.1702 11.2775 17.226 11.7636 17.5147C11.7732 17.5205 11.7771 17.5351 11.7959 17.5651C11.7467 17.6063 11.6943 17.6498 11.6424 17.6936C10.868 18.3464 10.32 19.1399 10.1457 20.1548C10.0002 21.0019 10.1014 21.8151 10.5328 22.5725C10.5798 22.6548 10.6256 22.7383 10.6945 22.8619C10.3997 22.7768 10.1399 22.721 9.8982 22.6056C9.04498 22.1976 8.37879 21.5888 7.92851 20.7532C7.6545 20.2449 7.49093 19.703 7.44898 19.1242C7.40203 18.4741 7.49786 17.8522 7.72916 17.2407C7.93544 16.6949 8.25679 16.2377 8.65974 15.8244C9.17006 15.301 9.77659 14.9238 10.4424 14.641C10.8684 14.4601 11.3125 14.3304 11.7848 14.3462C11.8471 14.3481 11.9095 14.3539 11.9818 14.3585C11.9737 14.5209 11.8856 14.6175 11.7832 14.7041C11.7494 14.733 11.7082 14.7534 11.6701 14.7768C11.5331 14.8603 11.4888 14.9862 11.5054 15.139C11.5335 15.3995 11.8821 15.6439 12.1281 15.5596C12.272 15.5104 12.4109 15.4954 12.5599 15.5069C12.6938 15.5173 12.8289 15.5134 12.9636 15.5138C13.7614 15.5161 14.4483 15.2186 15.0695 14.7391C15.5667 14.355 15.8958 13.8528 16.1225 13.2744C16.2314 12.9965 16.2702 12.7048 16.3045 12.4119C16.3095 12.368 16.3164 12.3241 16.3203 12.2961C16.7925 12.0678 17.2516 11.8462 17.7315 11.6145C17.7539 11.6718 17.7835 11.733 17.8012 11.7977C17.9232 12.2395 17.9259 12.6821 17.8189 13.1285C17.6723 13.7416 17.3667 14.2646 16.9614 14.7422C16.3311 15.485 15.5225 15.9456 14.6204 16.2658C14.1308 16.4394 13.6386 16.6045 13.1514 16.7838C12.9786 16.8477 12.8169 16.9428 12.6357 17.0309H12.6361ZM6.234 14.7264C5.70174 14.8896 5.20027 14.7965 4.71651 14.584C4.22813 14.3697 3.86406 14.0044 3.55964 13.5468C3.49652 14.1591 3.70742 14.6679 4.05764 15.1809C3.96066 15.1548 3.91062 15.1494 3.86829 15.1286C3.1209 14.7626 2.58403 14.2219 2.43163 13.3713C2.35966 12.9688 2.41431 12.5782 2.59557 12.2106C2.75683 11.8835 3.21096 11.661 3.58581 11.7149C3.74437 11.7376 3.90293 11.7599 4.06072 11.7861C4.43326 11.8477 4.78694 11.7834 5.13023 11.6353C5.43581 11.5032 5.73869 11.362 6.05196 11.2512C6.46953 11.1034 6.90403 11.0968 7.34315 11.1388C7.84538 11.1869 8.33069 11.2935 8.79097 11.5006C9.31899 11.7376 9.72463 12.1036 9.96055 12.6409C9.99018 12.7082 10.0079 12.781 10.0179 12.8641C9.05575 12.2787 8.01395 12.0521 6.90826 12.1067C6.61154 12.1213 6.31097 12.1563 6.01655 12.2837C6.15587 12.6374 6.40141 12.8853 6.67658 13.1077C6.95791 13.3348 7.29889 13.4264 7.65142 13.5057C7.48247 13.6838 6.77202 13.8062 6.21552 13.7104C5.71483 13.6242 5.27532 13.426 4.89701 13.025C4.93665 13.4475 5.11253 13.7662 5.34844 14.0571C5.58628 14.3508 5.88647 14.5632 6.23361 14.726L6.234 14.7264ZM20.7515 7.76862C20.8562 7.58619 20.9566 7.41109 21.0648 7.22289C21.1298 7.26061 21.1814 7.28447 21.226 7.31756C22.1635 8.018 22.7839 8.9328 23.0676 10.0689C23.1434 10.3725 23.1853 10.6843 23.1719 11.001C23.1669 11.1226 23.1318 11.2262 23.0425 11.3104C22.8667 11.4763 22.6165 11.4305 22.5191 11.2092C22.4914 11.1461 22.4783 11.0745 22.4683 11.0052C22.3144 9.9188 21.841 8.98514 21.1144 8.17271C20.9955 8.03994 20.8762 7.90755 20.7515 7.76862ZM19.2109 5.914C19.3749 5.61881 19.5261 5.34672 19.6905 5.05154C19.8202 5.0704 19.9599 5.08079 20.0946 5.11234C20.7642 5.26975 21.4119 5.48681 22.0054 5.84511C22.3529 6.05524 22.6692 6.30386 22.9375 6.60982C22.9914 6.67139 23.0406 6.74259 23.0706 6.81764C23.1249 6.95388 23.0649 7.06702 22.9671 7.16247C22.8721 7.2556 22.7601 7.26215 22.6488 7.20211C22.5649 7.1567 22.4853 7.10128 22.4106 7.04124C21.9442 6.66601 21.4111 6.42355 20.8435 6.24805C20.3532 6.09642 19.8529 5.99443 19.3429 5.93863C19.3056 5.9344 19.269 5.92516 19.2113 5.914H19.2109ZM12.7681 14.681C13.1425 14.0179 13.1233 13.3321 13.0317 12.6328H13.3838C13.3877 12.7386 13.3865 12.8268 13.3954 12.9134C13.4069 13.0273 13.4115 13.1447 13.4454 13.2524C13.5312 13.5222 13.94 13.6192 14.1339 13.3667C14.2244 13.249 14.2655 13.1196 14.2667 12.9746C14.2675 12.8733 14.2667 12.7717 14.2667 12.6463C14.6573 12.6028 15.0276 12.5616 15.4124 12.5185C15.417 12.5739 15.4301 12.6182 15.4224 12.6578C15.3239 13.1651 15.088 13.5972 14.6985 13.939C14.5546 14.0656 14.4014 14.183 14.2448 14.2938C13.843 14.5775 13.3792 14.6664 12.9008 14.7022C12.8708 14.7045 12.8396 14.6929 12.7681 14.6814V14.681ZM9.44561 6.36312C8.8995 6.33888 8.15442 6.60212 7.78073 6.95157C8.36032 7.37298 9.04844 7.12976 9.44561 6.36312Z"
                                                    fill="#DD8700" />
                                            </svg>
                                            <svg v-if="buyerGradeId==3"  xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_1916_11)">
                                                    <path
                                                        d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z"
                                                        fill="#51BB25" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1916_11">
                                                        <rect width="24" height="24" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            {{$t("lbl_EMPBE_SalesLead_SourcingGradType_"+buyerGradeId) }}
                                        </span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_ReportAll_Table_CompanyName") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactcompany
                                            }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Name") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactName }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t('lbl_EMPBE_CountryOrArea') }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{ countryName
                                        }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Mobile") }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactNumber }}</span>
                                    </div>
                                    <div class="productSourcingMatched-body-right-body-info">
                                        <span class="productSourcingMatched-body-right-body-info-title">{{
                                            $t('Lbl_EmailAddress') }}</span>
                                        <span class="productSourcingMatched-body-right-body-info-detail">{{
                                            ObjData.contactEmail }}</span>
                                    </div>

                                </div>
                                <span class="productSourcingMatched-body-right-body-text" v-html="GetContactTips"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            <div class="productSourcingMatched-remarks" v-if="mobile && messageBoardSourceId > 0">
                <MessageThread
                    :key="'remarks-sourcing-m-' + messageBoardSourceType + '-' + messageBoardSourceId"
                    :source-type="messageBoardSourceType"
                    :source-id="messageBoardSourceId"
                    log-form-type-prefix="SalesleadBack_"
                    :simulated-supplier="!!simulatedSupplier"
                    :max-depth="5"
                    :allow-create="true"
                    :allow-reply="false"
                    :allow-delete="false"
                    :root-level-only="true"
                />
            </div>

    </b-overlay>
</template>
<script>
import unlockToView from './unlockToView.vue';
import unlockQuota_Free from './unlockQuota_Free.vue';
import MessageThread from '@/components/MessageBoard/MessageThread.vue';
import { formatSalesLeadDate, formatSalesLeadViewedDate, isSalesLeadUnreadDate } from '@/_helpers/formatSalesLeadDate';
import { formatSalesLeadTitleWithCountry } from '@/_helpers/formatSalesLeadTitleWithCountry';
export default {
    props: {
        SalesLeadType: Number,
        ObjData: Object,
        loading: Boolean,
        mobile: Boolean,
        user: Object,
        /** 列表行 rid（与 GetSourcing*Detail 入参一致）；详情 JSON 常不含 rid，备注板依赖此值 */
        rid: {
            type: [Number, String],
            default: null
        },
        simulatedSupplier: {
            type: Boolean,
            default: false
        },
    },
    inject: ["permissionData", "GetDetail"],
    data() {
        return {
            isShowImageModal: false,
            ImageModalUrl: "",
            isContactLocked: true,
            yearRemainingQuota: null,
        }
    },
    components: {
        unlockToView,
        unlockQuota_Free,
        MessageThread
    },
    watch: {
        rid() {
            this.isContactLocked = true;
            this.yearRemainingQuota = null;
        },
    },
    computed: {
        /** 为贵司配对与贵司已申请都不走解锁额度 */
        isMatchedLead() {
            return this.SalesLeadType === 0 || this.SalesLeadType === '0';
        },
        buyerGradeId() {
            const d = this.ObjData || {};
            const raw = d.gradeId ?? d.GradeId ?? d.GradeID ?? 0;
            const n = Number(raw);
            return Number.isFinite(n) ? n : 0;
        },
        /** Figma Reminder=Exhibition Buyer：Contact info 顶部浅蓝提示 */
        isExhibitionBuyer() {
            return this.buyerGradeId === 4;
        },
        BoothType() {
            const raw = this.permissionData;
            if (!raw) return '';
            if (typeof raw === 'function') {
                try {
                    return raw()?.Type || '';
                } catch (e) {
                    return '';
                }
            }
            return raw?.Type || raw?.value?.Type || '';
        },
        isUnlockQuotaBooth() {
            return false;
        },
        isLeadUnlocked() {
            const d = this.ObjData || {};
            if (typeof d.isUnLocked !== 'undefined') {
                return d.isUnLocked === 1 || d.isUnLocked === true;
            }
            return false;
        },
        showUnlockBanner() {
            return this.isMatchedLead && this.isUnlockQuotaBooth && !this.visibilityTipText;
        },
        /** 本条已在额度解锁名单中 */
        isQuotaUnlocked() {
            return this.showUnlockBanner && !this.isContactLocked;
        },
        showContactHiddenBanner() {
            return this.showUnlockBanner && this.isContactLocked;
        },
        /** 仍锁定且额度已用尽 → 紫橙底；有额度 → 浅蓝 */
        isContactHiddenNoQuota() {
            if (this.yearRemainingQuota === null) return false;
            return Number(this.yearRemainingQuota) <= 0;
        },
        visibilityTipText() {
            if (!this.isMatchedLead) return '';
            const raw = this.ObjData?.visibilityReason
                || this.ObjData?.VisibilityReason
                || '';
            const reason = String(raw).toUpperCase();
            if (reason === 'TRANSITION') {
                return this.$t('lbl_EMPBE_SalesLead_VisibilityTip_Transition');
            }
            if (reason === 'PAID') {
                return this.$t('lbl_EMPBE_SalesLead_VisibilityTip_Paid');
            }
            return '';
        },
        messageBoardSourceId() {
            const fromList = Number(this.rid);
            if (Number.isFinite(fromList) && fromList > 0) {
                return fromList;
            }
            const raw =
                this.ObjData?.rid ??
                this.ObjData?.Rid ??
                this.ObjData?.id ??
                this.ObjData?.Id ??
                this.ObjData?.formId ??
                this.ObjData?.FormId ??
                this.ObjData?.formID ??
                this.ObjData?.requestId ??
                this.ObjData?.RequestId ??
                0;
            const num = Number(raw || 0);
            return Number.isFinite(num) ? num : 0;
        },
        /** 与 default.vue NavTabIndex 一致：0 为您匹配，1 贵司已申请 */
        messageBoardSourceType() {
            return this.SalesLeadType === 1
                ? 'SourcingRequest_Applied'
                : 'SourcingRequest_Matched';
        },
        langId() {
            return localStorage.getItem("currentLangId")
        },
        GetCodeText()
        {   
             var lang= "";
             if(this.langId==936)
                lang="simp";
             else if(this.langId==950)
                lang ="trad"
             else 
                lang ="eng"
              var url = process.env.VUE_APP_EMP_IsUat=="true" ? `https://www.chinaplasonline.com/eMarketplaceUAT/BuyerRequestInfoSupplier/${lang}?FormCode=${this.ObjData.formCode}` : `https://www.chinaplasonline.com/eMarketplace/BuyerRequestInfoSupplier/${lang}?FormCode=${this.ObjData.formCode}`;
               
            return this.$t("lbl_EMPBE_SalesLead_SourcingRef",{enquiryCode:this.ObjData.formCode,SourcingRequestUrl:url})
        },  
        GetContactTips()
        {
            return this.$t('lbl_EMPBE_SalesLead_RightDesc') ; 
        },
        GetFileType() {
            //图片0 pdf 1 word 2
            return function (item) {
                if (item.toLocaleLowerCase().includes(".jpeg") || item.toLocaleLowerCase().includes(".jpg"))
                    return 0;
                else if (item.toLocaleLowerCase().includes("pdf"))
                    return 1;
                else if(item.toLocaleLowerCase().includes("docx") || item.toLocaleLowerCase().includes(".doc"))
                    return 2
                else
                    return -1
            }
        },
        GetContactBuyerUrl() {
            return this.ObjData.productUrl.includes('https://') ? this.ObjData.productUrl : "https://" + this.ObjData.productUrl;
        },
        GetContactBuyerFiles() {
            var data = [];
            if (this.ObjData.files) {
                data = JSON.parse(this.ObjData.files);
            }
            return data.filter(item=>item.FileName !="");
        },
        unread() {
            const d = this.ObjData || {};
            return isSalesLeadUnreadDate(d.readDate || d.ReadDate);
        },
        unlockedChipLockImg() {
            const base = process.env.BASE_URL || '/';
            return `${base}img/epo-saleslead-unlocked-chip-lock.svg`;
        },
        viewedOnText() {
            const date = formatSalesLeadViewedDate(this.ObjData);
            if (!date) return '';
            if (this.isQuotaUnlocked) {
                return this.$t('lbl_EMPBE_SalesLead_UnlockedOn', { viewedDate: date });
            }
            return this.$t('lbl_EMPBE_SalesLead_ViewedOn', { viewedDate: date });
        },
        langId() {
            return localStorage.getItem("currentLangId")
        },
        countryName() {
            return this.ObjData.countryName;
        },
        title() {
            if (this.SalesLeadType == 0)
                return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_fromRequestMatching', {
                    buyerCountry: this.countryName,
                    compName: this.ObjData.contactcompany,
                });
            else if (this.SalesLeadType == 1)
                return this.$t('lbl_EMPBE_SalesLead_YourReplyTo', { compName: this.ObjData.contactcompany })

        },
        GetDate() {
            const date = formatSalesLeadDate(this.ObjData?.cdate || '');
            if (this.SalesLeadType == 0)
                return this.$t("lbl_EMPBE_SalesLead_MatchedDate", { sendDateOfEnquiry: date })
            else if (this.SalesLeadType == 1)
                return this.$t('lbl_EMPBE_SalesLead_ApprovedDate', { approvalDate: date })
            return '';
        }
    },
    methods: {
        ShowImgModel(url) {
            this.isShowImageModal = true;
            this.ImageModalUrl = url;
        },
        onUnlockQuota() {
            // unlockQuota_Free 成功后会自行 GetDetail；此处仅占位保持事件兼容
        },
        onUnlockQuotaInfo(info) {
            if (!info) return;
            if (typeof info.isLock !== 'undefined') {
                this.isContactLocked = !!info.isLock;
            }
            if (typeof info.yearRemainingQuota !== 'undefined') {
                this.yearRemainingQuota = Number(info.yearRemainingQuota);
            }
        },
    },
}
</script>
<style lang="scss">
@container (max-width:1278px) {
    .productSourcingMatched-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;

        .productSourcingMatched-detail {
            display: flex;
            padding: 16px;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            border-radius: 24px;
            background: var(--Surface, #FFF);
            box-shadow: 0px 2px 15px 0px rgba(183, 183, 183, 0.30);

            .productSourcingMatched-unLock {
                width: 100%;
            }

            .productSourcingMatched-header-container {
                display: flex;
                align-items: center;
                gap: 15px;
                align-self: stretch;
            }

            .productSourcingMatched-header {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 4px;
                flex: 1 0 0;

                .productSourcingMatched-title {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 8px;
                    align-self: stretch;
                    min-width: 0;
                    max-width: 100%;

                    .productSourcingMatched-title-name {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 150%;
                        /* 30px */
                        letter-spacing: -0.22px;
                        min-width: 0;
                        max-width: 100%;
                        white-space: normal;
                        word-break: break-word;
                        overflow-wrap: anywhere;
                    }

                    .productSourcingMatched-title-unread {
                        display: flex;
                        padding: 2px 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 4px;
                        border-radius: 125px;
                        background: var(--primary-supplier-backend, #7366FF);
                        color: var(--M3-sys-light-on-error, #FFF);
                        text-align: center;
                        font-family: Roboto;
                        font-size: 13.75px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 20px;
                        /* 145.455% */
                        text-wrap: nowrap;
                        flex-shrink: 0;
                    }

                    .productSourcingMatched-title-viewed {
                        color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 30px;
                        white-space: nowrap;
                        flex-shrink: 0;
                    }
                    .productSourcingMatched-title-viewed.is-unlocked {
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                        padding: 2px 8px;
                        border-radius: 125px;
                        background: #37B400;
                        color: #FFFFFF;
                        font-size: 13px;
                        font-weight: 600;
                        line-height: 150%;
                    }
                    .productSourcingMatched-title-viewed__lock {
                        display: block;
                        flex-shrink: 0;
                        width: 15px;
                        height: 16px;
                    }
                }

                .productSourcingMatched-subtitle {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 4px;
                    min-width: 0;

                    .productSourcingMatched-subtitle-unicode {
                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                        word-break: break-word;
                        overflow-wrap: anywhere;
                    }
                    .productSourcingMatched-subtitle-unicode  a
                    {
                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 150%;
                        text-decoration: underline;
                    }

                    .productSourcingMatched-subtitle-date {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                    }
                }
            }

            .productSourcingMatched-body-container {
                display: flex;
                padding: 8px 16px;
                justify-content: center;
                align-items: flex-start;
                align-self: stretch;
                border-radius: 16px;
                background: #F2F3F5;
                text-wrap: auto;

                .productSourcingMatched-body {
                    display: flex;
                    padding: 8px 0px;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 16px;
                    flex: 1 0 0;

                    .productSourcingMatched-body-left {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        align-self: stretch;

                        .file-BG {
                            display: flex;
                            align-items: flex-start;
                            align-content: flex-start;
                            gap: 8px;
                            align-self: stretch;
                            flex-wrap: wrap;
                        }

                        .file-Bg-Nav {
                            display: flex;
                            width: 104px;
                            height: 104px;
                            aspect-ratio: 1;
                            flex-direction: column;
                            align-items: center;
                            gap: 3px;
                            border-radius: 4px;
                            overflow: hidden;
                            justify-content: center;
                            background: #F9F9F9;
                        }

                        .file-Bg-Nav img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }

                        .productSourcingMatched-body-left-ContactBuyer {
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            overflow-wrap: break-word;
                            word-break: break-all;
                        }

                        .productSourcingMatched-body-left-ContactBuyer-Svg svg {
                            margin-left: 10px;
                            height: 50%;
                        }

                        .productSourcingMatched-body-left-ContactBuyer-Nav {
                            flex: 1;
                            margin-top: 16px;
                        }

                        .productSourcingMatched-body-left-Title {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            align-self: stretch;
                        }

                        .productSourcingMatched-body-left-header {
                            height: 27px;
                            align-self: stretch;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .productSourcingMatched-body-left-header-Date {
                            color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 150%;
                            /* 21px */
                        }

                        .productSourcingMatched-body-left-requirment-container {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 16px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;
                            margin-top: 4px;

                            .productSourcingMatched-body-left-requirment-product {
                                display: flex;
                                align-items: center;
                                gap: 16px;
                                align-self: stretch;

                                .productSourcingMatched-body-left-requirment-product-name-container {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    flex: 1 0 0;
                                    align-self: stretch;

                                    .productSourcingMatched-body-left-requirment-product-name {
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        flex: 1 0 0;
                                        align-self: stretch;
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-size: 18px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 150%;
                                        /* 27px */
                                        letter-spacing: -0.198px;

                                    }
                                }

                                .productSourcingMatched-body-left-requirment-product-img-container {
                                    display: flex;
                                    width: 96px;
                                    height: 96px;
                                    padding: 12.243px 0px 11.757px 0px;
                                    justify-content: center;
                                    align-items: center;
                                    border-radius: 12px;
                                    background-color: #f9f9f9;
                                    overflow: hidden;
                                    flex-shrink: 0;

                                    img {
                                        width: 96px;
                                        height: 72px;
                                        flex-shrink: 0;
                                        object-fit: cover;
                                        background: #d3d3d3;
                                    }
                                }
                            }

                            .productSourcingMatched-body-left-requirment {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                align-self: stretch;

                                .productSourcingMatched-body-left-requirment-title {
                                    color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                    font-feature-settings: 'liga' off, 'clig' off;
                                    /* Text/Paragraph 3 */
                                    font-size: 12px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 150%;
                                    /* 18px */
                                }

                                .productSourcingMatched-body-left-requirment-detail-container {
                                    display: flex;
                                    align-items: flex-start;
                                    align-content: flex-start;
                                    gap: 2px;
                                    align-self: stretch;
                                    flex-wrap: wrap;


                                    .natureText {
                                        color: #FFF !important;
                                        font-size: 13px !important;
                                        font-weight: 700 !important;
                                        line-height: 18px !important;
                                        letter-spacing: 0.16px !important;
                                        padding: 3px 4px !important;
                                        background-image: linear-gradient(-45deg, #37b400, #287706) !important;
                                        display: inline-block !important;
                                        border-radius: 4px !important;
                                    }

                                    .productSourcingMatched-body-left-requirment-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                        min-width: 0;
                                        max-width: 100%;
                                        white-space: normal;
                                        word-break: break-word;
                                        overflow-wrap: anywhere;
                                    }
                                }
                            }

                        }
                    }

                    .productSourcingMatched-body-right {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 4px;
                        align-self: stretch;

                        .productSourcingMatched-body-right-title {
                            height: 27px;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .productSourcingMatched-body-right-body {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 20px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;
                            .productSourcingMatched-body-right-Exhibitiongrade
                            {
                                color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                font-size: 14px;
                                font-weight: 400;
                                line-height: 150%;
                                letter-spacing: 0.15px;
                                display: flex;
                                padding: 16px;
                                flex-direction: column;
                                align-items: flex-start;
                                gap: 7px;
                                align-self: stretch;
                                border-radius: 8px;
                                background: #E7F8FF;
                            }
                            .productSourcingMatched-body-right-body-info-container {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                gap: 8px;
                                align-self: stretch;

                                .productSourcingMatched-body-right-body-info {
                                    display: flex;
                                    align-items: flex-start;
                                    align-self: stretch;
                                    flex-direction: column;

                                    .productSourcingMatched-body-right-body-info-title {
                                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        width: 160px;
                                        font-size: 12px;
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: 150%;
                                        /* 18px */
                                    }

                                    .productSourcingMatched-body-right-body-info-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                        display: flex;
                                        flex-wrap: wrap;
                                        align-items: flex-start;
                                        min-width: 0;
                                        max-width: 100%;
                                        white-space: normal;
                                        word-break: break-word;
                                        overflow-wrap: anywhere;
                                        svg
                                        {
                                            margin-right: 3px;
                                        }
                                    }
                                }

                            }

                            .productSourcingMatched-body-right-body-text {
                                align-self: stretch;
                                color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                font-feature-settings: 'liga' off, 'clig' off;
                                font-size: 12px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 150%;
                                padding-top: 16px;
                                border-top: 1px solid #F2F3F5;
                            }
                        }
                    }

                }
            }

        }
    }
}

@container (min-width:1279px) {
    .productSourcingMatched-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;
        align-self: stretch;

        .productSourcingMatched-detail {
            display: flex;
            padding: 24px;
            flex-direction: column;
            align-items: flex-start;
            gap: 24px;
            align-self: stretch;
            border-radius: 24px;
            background: var(--Surface, #FFF);
            /* Surface shadow */
            box-shadow: 0px 2px 15px 0px rgba(183, 183, 183, 0.30);

            .productSourcingMatched-unLock {
                width: 100%;
            }

            .productSourcingMatched-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                align-self: stretch;
                flex-wrap: wrap;
                gap: 8px;
                min-width: 0;

                .productSourcingMatched-title {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 8px;
                    flex: 1 1 0;
                    min-width: 0;
                    max-width: 100%;

                    .productSourcingMatched-title-name {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 150%;
                        /* 30px */
                        letter-spacing: -0.22px;
                        min-width: 0;
                        max-width: 100%;
                        white-space: normal;
                        word-break: break-word;
                        overflow-wrap: anywhere;
                    }

                    .productSourcingMatched-title-unread {
                        display: flex;
                        padding: 2px 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 4px;
                        border-radius: 125px;
                        background: var(--primary-supplier-backend, #7366FF);
                        color: var(--M3-sys-light-on-error, #FFF);
                        text-align: center;
                        font-family: Roboto;
                        font-size: 13.75px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 20px;
                        /* 145.455% */
                        flex-shrink: 0;
                    }

                    .productSourcingMatched-title-viewed {
                        color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 30px;
                        white-space: nowrap;
                        flex-shrink: 0;
                    }
                    .productSourcingMatched-title-viewed.is-unlocked {
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                        padding: 2px 8px;
                        border-radius: 125px;
                        background: #37B400;
                        color: #FFFFFF;
                        font-size: 13px;
                        font-weight: 600;
                        line-height: 150%;
                    }
                    .productSourcingMatched-title-viewed__lock {
                        display: block;
                        flex-shrink: 0;
                        width: 15px;
                        height: 16px;
                    }
                }

                .productSourcingMatched-subtitle {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 4px;
                    flex-shrink: 0;

                    .productSourcingMatched-subtitle-unicode {
                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                        word-break: break-word;
                        overflow-wrap: anywhere;
                    }
                    .productSourcingMatched-subtitle-unicode  a
                    {
                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 150%;
                        text-decoration: underline;
                    }

                    .productSourcingMatched-subtitle-date {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                    }
                }
            }

            .productSourcingMatched-body-container {
                display: flex;
                padding: 8px 16px;
                justify-content: center;
                align-items: flex-start;
                align-self: stretch;
                border-radius: 16px;
                background: #F2F3F5;

                .productSourcingMatched-body {
                    display: flex;
                    padding: 8px 0px;
                    align-items: flex-start;
                    align-content: flex-start;
                    gap: 16px;
                    flex: 1 0 0;
                    flex-wrap: wrap;
                    min-width: 0;
                    max-width: 100%;

                    .productSourcingMatched-body-left {
                        display: flex;
                        min-width: 0;
                        max-width: 100%;
                        flex-direction: column;
                        align-items: flex-start;
                        flex: 1 1 736px;

                        .file-BG {
                            display: flex;
                            align-items: flex-start;
                            align-content: flex-start;
                            gap: 8px;
                            align-self: stretch;
                            flex-wrap: wrap;
                        }

                        .file-Bg-Nav {
                            display: flex;
                            width: 104px;
                            height: 104px;
                            aspect-ratio: 1;
                            flex-direction: column;
                            align-items: center;
                            gap: 3px;
                            border-radius: 4px;
                            overflow: hidden;
                            justify-content: center;
                            background: #F9F9F9;
                        }

                        .file-Bg-Nav img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }

                        .productSourcingMatched-body-left-ContactBuyer {
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            overflow-wrap: break-word;
                            word-break: break-all;
                        }

                        .productSourcingMatched-body-left-ContactBuyer-Svg svg {
                            margin-left: 10px;
                            height: 50%;
                        }

                        .productSourcingMatched-body-left-ContactBuyer-Nav {
                            flex: 1;
                            margin-top: 16px;
                        }

                        .productSourcingMatched-body-left-Title {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            align-self: stretch;
                        }

                        .productSourcingMatched-body-left-header {
                            height: 27px;
                            align-self: stretch;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .productSourcingMatched-body-left-header-Date {
                            color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 150%;
                            /* 21px */
                        }

                        .productSourcingMatched-body-left-requirment-container {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 16px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;
                            margin-top: 4px;

                            .productSourcingMatched-body-left-requirment-product {
                                display: flex;
                                align-items: center;
                                gap: 16px;
                                align-self: stretch;

                                .productSourcingMatched-body-left-requirment-product-name-container {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    flex: 1 0 0;
                                    align-self: stretch;

                                    .productSourcingMatched-body-left-requirment-product-name {
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        flex: 1 0 0;
                                        align-self: stretch;
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-size: 18px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 150%;
                                        /* 27px */
                                        letter-spacing: -0.198px;

                                    }
                                }


                                .productSourcingMatched-body-left-requirment-product-img-container {
                                    display: flex;
                                    width: 96px;
                                    height: 96px;
                                    padding: 12.243px 0px 11.757px 0px;
                                    justify-content: center;
                                    align-items: center;
                                    border-radius: 12px;
                                    background-color: #f9f9f9;
                                    overflow: hidden;
                                    flex-shrink: 0;

                                    img {
                                        width: 96px;
                                        height: 72px;
                                        flex-shrink: 0;
                                        object-fit: cover;
                                        background: #d3d3d3;
                                    }
                                }
                            }

                            .productSourcingMatched-body-left-requirment {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                align-self: stretch;

                                .productSourcingMatched-body-left-requirment-title {
                                    color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                    font-feature-settings: 'liga' off, 'clig' off;
                                    /* Text/Paragraph 3 */
                                    font-size: 12px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 150%;
                                    /* 18px */
                                }

                                .productSourcingMatched-body-left-requirment-detail-container {
                                    display: flex;
                                    align-items: flex-start;
                                    align-content: flex-start;
                                    gap: 2px;
                                    align-self: stretch;
                                    flex-wrap: wrap;

                                    .natureText {
                                        color: #FFF !important;
                                        font-size: 13px !important;
                                        font-weight: 700 !important;
                                        line-height: 18px !important;
                                        letter-spacing: 0.16px !important;
                                        padding: 3px 4px !important;
                                        background-image: linear-gradient(-45deg, #37b400, #287706) !important;
                                        display: inline-block !important;
                                        border-radius: 4px !important;
                                    }

                                    .productSourcingMatched-body-left-requirment-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                        min-width: 0;
                                        max-width: 100%;
                                        white-space: normal;
                                        word-break: break-word;
                                        overflow-wrap: anywhere;
                                    }
                                }
                            }

                        }
                    }

                    .productSourcingMatched-body-right {
                        display: flex;
                        min-width: 0;
                        max-width: 100%;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 4px;
                        flex: 1 1 368px;

                        .productSourcingMatched-body-right-title {
                            width: 100%;
                            max-width: 100%;
                            height: 27px;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .productSourcingMatched-body-right-body {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 20px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;
                            .productSourcingMatched-body-right-Exhibitiongrade
                            {
                                color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                font-size: 14px;
                                font-weight: 400;
                                line-height: 150%;
                                letter-spacing: 0.15px;
                                display: flex;
                                padding: 16px;
                                flex-direction: column;
                                align-items: flex-start;
                                gap: 7px;
                                align-self: stretch;
                                border-radius: 8px;
                                background: #E7F8FF;
                            }

                            .productSourcingMatched-body-right-body-info-container {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                gap: 8px;
                                align-self: stretch;

                                .productSourcingMatched-body-right-body-info {
                                    display: flex;
                                    align-items: flex-start;
                                    align-self: stretch;
                                    gap: 8px;
                                    min-width: 0;
                                    max-width: 100%;

                                    .productSourcingMatched-body-right-body-info-title {
                                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        width: 160px;
                                        font-size: 12px;
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: 150%;
                                        /* 18px */
                                    }

                                    .productSourcingMatched-body-right-body-info-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                        display: flex;
                                        flex-wrap: wrap;
                                        align-items: flex-start;
                                        min-width: 0;
                                        max-width: 100%;
                                        white-space: normal;
                                        word-break: break-word;
                                        overflow-wrap: anywhere;
                                        svg
                                        {
                                            margin-right: 3px;
                                        }
                                    }
                                }

                            }

                            .productSourcingMatched-body-right-body-text {
                                align-self: stretch;
                                color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                font-feature-settings: 'liga' off, 'clig' off;
                                font-size: 12px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 150%;
                                padding-top: 16px;
                                border-top: 1px solid #F2F3F5;
                            }
                        }
                    }

                }
            }

        }
    }
}

.productSourcingMatched-container {
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
}

.productSourcingMatched-detail {
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
}

.productSourcingMatched-title-name,
.productSourcingMatched-body-right-body-info-detail,
.productSourcingMatched-body-left-requirment-detail,
.productSourcingMatched-body-left-header,
.productSourcingMatched-body-left-header-Date {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    max-width: 100%;
    min-width: 0;
}

/* Exhibition Buyer tip — left column under Sourcing Request Details title */
.productSourcingMatched-exhibition-banner {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    box-sizing: border-box;
    margin: 8px 0 4px;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #B8E7F7;
    background: #E7F8FF;
}

.productSourcingMatched-exhibition-banner__icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-top: 1px;
    display: block;
}

.productSourcingMatched-exhibition-banner__text {
    flex: 1 1 auto;
    min-width: 0;
    color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.15px;
}

.productSourcingMatched-remarks {
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
    margin-top: 20px;
}
</style>